// ha — checkin/quickCheck/stepTracker blocks translated.
export const ha = {
  "common": {
    "loading": "Ana loding...",
    "save": "Ajiye",
    "cancel": "Soke",
    "delete": "Goge",
    "edit": "Gyara",
    "close": "Rufe",
    "confirm": "Tabbatar",
    "back": "Baya",
    "next": "Gaba",
    "submit": "Aika",
    "search": "Nema",
    "select": "Zaɓa",
    "or": "Ko",
    "and": "da",
    "note": "Lura",
    "viewAll": "Duba Duka",
    "learnMore": "Ƙara Sani",
    "getStarted": "Fara Yanzu",
    "continue": "Ci gaba",
    "saving": "Ana ajiyewa…"
  },
  "nav": {
    "dashboard": "Gida",
    "nutrition": "Abinci",
    "family": "Iyali",
    "care": "Ayyuka",
    "careShort": "Ayyuka",
    "checkIn": "Duba Lafiya",
    "insights": "Sani",
    "trends": "Alamu",
    "habits": "Hali",
    "medications": "Magunguna",
    "expertSupport": "Taimakon Masana",
    "profile": "Bayanai",
    "healthHub": "Matattarar Lafiya",
    "support": "Taimako",
    "wellness": "Inganta Lafiya",
    "education": "Ilimi",
    "community": "Al'umma",
    "preventiveHealth": "Rigakafin Lafiya",
    "womensHealth": "Lafiyar Mata",
    "reminders": "Tunasarwa",
    "meals": "Abinci",
    "orders": "Oda",
    "subscription": "Biyan Kuɗi",
    "logout": "Fita"
  },

  "navShort": {
    "dashboard": "Gida",
    "nutrition": "Abinci",
    "family": "Iyali",
    "care": "Sabis",
    "support": "Taimako",
    "profile": "Bayani"
  },
  "auth": {
    "login": "Shiga",
    "register": "Bude Akanta",
    "logout": "Fita",
    "email": "Imel",
    "password": "Kalmar Sirri",
    "name": "Cikakken Suna",
    "forgotPassword": "Ka manta kalmar sirri?",
    "noAccount": "Ba ka da akanta?",
    "haveAccount": "Kana da akanta tuni?",
    "signInHere": "Shiga a nan",
    "signUpHere": "Yi rajista a nan",
    "welcomeBack": "Barka da dawowa!",
    "getStarted": "Bari mu fara",
    "biometricLogin": "Shiga da Biometrics",
    "biometricHelper": "Yi amfani da yatsa, fuska, ko Windows Hello",
    "vendorLogin": "Shigar Mai Sayarwa",
    "createOne": "Bude guda ɗaya",
    "tagline": "Sanya idon ga lafiyarka — duba ɗaya mai sauƙi a kowace rana.",
    "takes30s": "Ba ya wuce sakan 30",
    "emailPlaceholder": "sunanka@misali.com",
    "passwordPlaceholder": "Shigar da kalmar sirri",
    "checking": "Ana dubawa…",
    "continue": "Ci gaba",
    "secureMessage": "Lafiyayye kuma na sirri — bayananka suna nan a kiyaye",
    "biometricSoon": "Shiga da Biometrics — Nan kusa",
    "sessionExpired": "Lokacin zamanka ya ƙare. Da fatan za ka sake shiga don ci gaba daga inda ka tsaya.",
    "showPassword": "Nuna kalmar sirri",
    "hidePassword": "Ɓoye kalmar sirri",
    "vendor": {
      "title": "Shigar Masu Sayarwa",
      "subtitle": "Shiga cikin shafin gudanarwar masu sayarwa na HealthLoop",
      "businessEmail": "Imel na Kasuwanci",
      "emailPlaceholder": "mai-sayarwa@kasuwanci.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Ana shiga...",
      "signIn": "Shiga",
      "notVendorYet": "Ba ka zama abokin kasuwanci ba tukuna?",
      "registerBusiness": "Yi rajistar kasuwancinka",
      "areYouUser": "Kai mai amfani ne?",
      "userLogin": "Shigar Mai Amfani",
      "welcomeBackToast": "Barka da dawowa!",
      "genericError": "Shiga bai nasara ba. Da fatan za a sake gwadawa."
    },
    "admin": {
      "backToUserLogin": "Shigar mai amfani",
      "title": "Shigar Shugaba (Admin)",
      "restrictedBadge": "An Taƙaita",
      "tagline": "Shafin gudanarwa na HealthLoop — ana buƙatar bayanan shugaba.",
      "emailLabel": "Imel na Admin",
      "emailPlaceholder": "admin@kamfaninka.com",
      "passwordLabel": "Kalmar sirri",
      "passwordPlaceholder": "Shigar da kalmar sirrinka na admin",
      "signingIn": "Ana shiga…",
      "submit": "Shiga shafin gudanarwa",
      "secureNote": "Haɗin yanar gizo mai kariya · an ɓoye bayanan zaman",
      "restrictedTitle": "Wannan wurin na shugabanni (admins) ne kawai.",
      "restrictedBody": "Asusunka ya riga ya shiga, amma ba shi da ikon shugaba. Fita don gwada wani asusun daban, ko ka koma babban shafin aikace-aikacen.",
      "signOut": "Fita",
      "backToApp": "Koma shafin aikace-aikacen"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Yaya kuke ji a yau?",
      "subtitle": "Bincike mai sauri — ba zai kai sakan 60 ba"
    },
    "section1": {
      "title": "Me kuke lura da shi a yau?",
      "hint": "(Zaɓi duk abubuwan da suka dace)"
    },
    "environment": {
      "title": "Yanayin kewayenku yau",
      "hint": "Taimaka mana mu fahimci inda kuke"
    },
    "basicChecks": {
      "title": "Gajeren binciken yau da kullum",
      "hint": "Za ku iya tsallakawa, amma yana da amfani"
    },
    "validation": {
      "pickOne": "Da fatan za a amsa aƙalla tambaya ɗaya"
    },
    "submit": {
      "cta": "Samu Bayanan Lafiyata",
      "saving": "Ana adanawa...",
      "analyzing": "Ana nazarin tsarin lafiyarku...",
      "savedToast": "✅ An ajiye binciken! Ana nazarin tsarin lafiyarku..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Ma'aunin Takun Tafi",
      "subtitle": "Bibiyar motsa jiki ta gaskiya a nan kusa",
      "backToDashboard": "Koma zuwa jadawalin"
    },
    "today": {
      "title": "Takun tafiyar yau",
      "goalProgress": "Taku {{current}} / {{goal}}",
      "goalReached": "An cimma buri — ƙoƙari sosai!",
      "keepGoing": "Ci gaba da tafiya — kuna kan hanya."
    },
    "streak": {
      "label": "Kwanaki a jere",
      "days": "kwana {{count}}",
      "daysPlural": "kwanaki {{count}}"
    },
    "badges": {
      "title": "Lambar Yabo",
      "empty": "Za ku sami lambobin yabo yayin da kuka saba da wannan ɗabi'ar."
    },
    "reminders": {
      "title": "Tunasarwar Motsi",
      "hint": "Tunasarwa mai daɗi don yin ɗan gajeren tafi idan kun zauna na tsawon lokaci.",
      "enabled": "An kunna",
      "disabled": "An kashe"
    },
    "insights": {
      "weeklyAverage": "Matsakaicin mako",
      "weeklyGoal": "Burin mako"
    },
    "actions": {
      "connect": "Haɗa hanyar kirga taku",
      "manualLog": "Rubuta taku da kanku",
      "changeGoal": "Canza burin kullum"
    }
  },
  "checkin": {
    "header": {
      "title": "Binciken Lafiyar Kullum",
      "subtitle": "Ba zai ɗauki fiye da sakan 60 ba",
      "restDayLink": "Ba na jin daɗin jikina a yau"
    },
    "snapshot": {
      "title": "Sabuwar jadawalin ku",
      "healthScore": "Makin lafiya",
      "todayTasks": "Ayyukan yau",
      "dayStreak": "yawan kwanaki"
    },
    "resume": {
      "banner": "An ci gaba daga inda aka tsaya",
      "startFresh": "Fara sabo",
      "dismiss": "Cire"
    },
    "progress": {
      "allSet": "An gama",
      "step": "Mataki {{current}} cikin {{total}}",
      "ariaLabel": "Ci gaban binciken kullum: sassa {{done}} cikin {{total}} sun kammala"
    },
    "insights": {
      "title": "Bayanan Lafiyarku",
      "subtitle": "An tsara su musamman don ku a yau",
      "insightForYou": "Bayanai gare ku",
      "simpleActions": "Matakai masu sauƙi da za ku iya ɗauka",
      "whenToSeekHelp": "Yaushe za a nemi taimako",
      "nhsAdvice": "Idan kuna damuwa, tuntuɓi NHS 111 ko likitanku",
      "backToDashboard": "Koma zuwa Jadawalin",
      "newCheckIn": "Sabuwar Dubawa",
      "disclaimer": "HealthLoop yana ba da jagora ne, ba duba na likita ba."
    },
    "restDay": {
      "title": "Hutu yana cikin tsarin rayuwa.",
      "body": "Za mu kasance a nan gobe idan kun shirya.",
      "streakNote": "Kwanakinku ba su canza ba — su ma hutawa suke yi.",
      "backToDashboard": "Koma zuwa jadawalin",
      "changedMind": "A gaskiya, ina so in yi binciken kawai."
    },
    "feelings": {
      "title": "Yaya kuke ji a yau?",
      "hint": "Zaɓi duk abubuwan da kuke ji",
      "tired": "Ina jin gajiya",
      "headache": "Ciwon kai",
      "stressed": "Cikin damuwa ko nauyin rai",
      "pain": "Ciwon jiki ko gaɓoɓi",
      "okay": "Ina jin daidai a yau"
    },
    "basics": {
      "title": "Abubuwan yau da kullum",
      "sleepQ": "Kun yi barci mai daɗi jiya?",
      "waterQ": "Kun sha isasshen ruwa yau?",
      "foodQ": "Kun ci abinci yadda ya kamata yau?",
      "activityQ": "Yaya kazar-kazarku take a yau?",
      "yes": "Eh",
      "notReally": "Ba sosae ba",
      "notYet": "Tukuna",
      "notActive": "Babu motsi",
      "lightActivity": "Motsi kaɗan",
      "active": "Ina da kazar-kazar"
    },
    "mind": {
      "title": "Hankali da Kuzari",
      "stressQ": "Yaya matakin damuwarku yake yau?",
      "moodQ": "Yaya yanayin zuciyarku yake yau?",
      "energyQ": "Yaya matakin kuzarinku yake yau?",
      "low": "Kasa",
      "moderate": "Tsaka-tsaki",
      "high": "Sama",
      "neutral": "Ba laifi",
      "good": "Da kyau",
      "okay": "Lafiya"
    },
    "day": {
      "title": "Ranarku",
      "routineQ": "Kun bi tsarin ayyukanku na yau da kullum?",
      "yes": "Eh",
      "no": "A'a"
    },
    "environment": {
      "title": "Yanayin kewayenku yau",
      "describeQ": "Yaya za ku siffanta yanayin kewayenku?",
      "comfortable": "😊 Da daɗi",
      "slightlyUncomfortable": "😐 Akwai ɗan takura",
      "challenging": "😓 Akwai wahala",
      "affectedQ": "Wuraren da kuka kasance sun shafi yadda kuke ji?",
      "yes": "Eh",
      "no": "A'a",
      "exposureLabel": "Abubuwan da kuka haɗu da su (zaɓi duk wanda ya dace)",
      "heat": "🌡️ Zafi",
      "cold": "❄️ Sanyi",
      "noise": "🔊 Hayaniya",
      "dustSmoke": "💨 Kura ko hayaki",
      "crowded": "👥 Cunkoson mutane",
      "none": "✅ Babu"
    },
    "submit": {
      "analyzing": "Ana nazarin tsarin lafiyarku...",
      "cta": "Duba Bayanan Lafiyata"
    },
    "toast": {
      "savedFull": "An ajiye binciken! An sabunta jadawalinku.",
      "savedShort": "An ajiye binciken."
    }
  },
  "onboarding": {
    "welcome": "Barka da zuwa",
    "completeSetup": "Kammala Tsari",
    "stepProgress": "Mataki {{step}} na {{total}}",
    "percentComplete": "{{percent}}% an kammala",
    "welcomeToast": "Barka da zuwa HealthLoop! An shirya bayananka.",
    "errorAgeRange": "Da fatan za ka zaɓi shekarunka",
    "errorCountry": "Da fatan za ka zaɓi ƙasarka",
    "errorGoal": "Da fatan za ka zaɓi babban burinka na lafiya",
    "errorCuisine": "Da fatan za ka zaɓi aƙalla nau'in abinci ɗaya",
    "errorGeneric": "An kasa kammala tsarin. Sake gwadawa.",
    "step1Title": "Barka da zuwa HealthLoop! 👋",
    "step1Subtitle": "Bari mu tsara tafiyar lafiyarka yadda ya dace da kai",
    "ageRangeLabel": "Nawa ne shekarunka?",
    "genderLabel": "Jinsi (Na zaɓi)",
    "gender_male": "Namiji",
    "gender_female": "Mace",
    "gender_non-binary": "Ba mace ko namiji ba",
    "gender_prefer_not_to_say": "Gwamma kada a faɗa",
    "step2Title": "Ina kake zaune? 🌍",
    "step2Subtitle": "Wannan zai taimaka mana wajen ba da shawarar abincin al'adarka",
    "countryLabel": "Zaɓi ƙasarka",
    "country_uk": "Burtaniya (UK)",
    "country_nigeria": "Najeriya",
    "country_ghana": "Gana",
    "country_kenya": "Kenya",
    "country_south_africa": "Afirka Ta Kudu",
    "country_usa": "Amurka (USA)",
    "country_canada": "Kanada",
    "country_india": "Indiya",
    "country_jamaica": "Jamaika",
    "country_other": "Wani wuri",
    "step3Title": "Mene ne babban burinka? 🎯",
    "step3Subtitle": "Zaɓi ainihin abin da kake son cimmawa",
    "additionalGoals": "Akwai wasu burikan? (Na zaɓi)",
    "goal_weight_loss": "Rage Kiba",
    "goalDesc_weight_loss": "Rage nauyi cikin koshin lafiya",
    "goal_weight_maintenance": "Kula da Nauyi",
    "goalDesc_weight_maintenance": "Kasancewa a nauyin da kake kai yanzu",
    "goal_muscle_gain": "Gina Jiki",
    "goalDesc_muscle_gain": "Samun ƙarfi da tsokar jiki",
    "goal_general_wellness": "Inganta Lafiya",
    "goalDesc_general_wellness": "Inganta lafiyar jiki gaba ɗaya",
    "goal_better_sleep": "Bacci Mai Kyau",
    "goalDesc_better_sleep": "Inganta ingancin bacci",
    "goal_reduce_stress": "Rage Damuwa",
    "goalDesc_reduce_stress": "Kula da damuwa yadda ya kamata",
    "goal_increase_energy": "Samun Ƙarfi",
    "goalDesc_increase_energy": "Jin ƙarin kuzari a jiki",
    "step4Title": "Abincin da aka fi so 🍽️",
    "step4Subtitle": "Zaɓi abincin da kake so da duk wani abinci da ba ka ci",
    "cuisineLabel": "Abincin da Aka Fi So",
    "cuisineHint": "Zaɓi aƙalla ɗaya (za ka iya zaɓar da yawa)",
    "dietaryLabel": "Abubuwan da Ba a Ci (Na zaɓi)",
    "diet_vegetarian": "Kayan Ganye (Vegetarian)",
    "diet_vegan": "Kayan Ganye Kawai (Vegan)",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Babu Gluten",
    "diet_dairy_free": "Babu Madara",
    "diet_pescatarian": "Masu cin kifi (Pescatarian)",
    "step5Title": "Yanayin lafiya 🏥",
    "step5Subtitle": "Na zaɓi — yana taimaka mana mu ba ka shawarwarin da suka dace",
    "conditionsLabel": "Shin kana da ɗaya daga cikin waɗannan yanayin?",
    "conditionsHint": "Wannan bayanin na sirri ne kuma zai taimaka wajen tsara abubuwan da za mu nuna maka",
    "condition_diabetes": "Ciwon Suga",
    "condition_hypertension": "Hawan Jini",
    "condition_heart_disease": "Ciwon Zuciya",
    "condition_thyroid": "Matsalar Thyroid",
    "condition_celiac": "Ciwon Celiac",
    "condition_ibs": "Ciwon Ciki (IBS)",
    "condition_none": "Babu ɗaya",
    "privacyTitle": "An kiyaye bayananka",
    "privacyBody": "Bayananka na sirri an ruffe su kuma an ajiye su cikin aminci. Muna amfani da waɗannan bayanan ne kawai don tsara abincin da ya dace da kai, shawarwarin lafiya, da tunatarwa. Ba za mu taba raba bayananka da wani ba tare da izininka ba.",
    "trackMedication": "Ina son bibiyar magungunana",
    "specialistInterest": "Ina son tuntuɓar ƙwararrun likitoci",
    "welcomeTitle": "Barka da zuwa HealthLoop! 👋",
    "welcomeSubtitle": "Bari mu tsara maka bayanan kariya da inganta rayuwa cikin sauki ta hanyar fasahar AI",
    "stepLabel": "Mataki na {{current}} cikin {{total}}",
    "skipForNow": "Tsallake yanzu",
    "skipToast": "Zaka iya karasa wannan saitin a kowane lokaci daga bayanan ka (profile)",
    "back": "Baya",
    "next": "Gaba",
    "completing": "Ana gamawa...",
    "complete": "Kammala Saiti",
    "successToast": "Barka da zuwa HealthLoop! Mun riga mun tsara komai dominka 🎉",
    "failureToast": "An kasa kammala saitin shiga",
    "validation": {
      "basicInfo": "Da fatan za a cike dukkan muhimman bayanai",
      "pickGoal": "Da fatan za a zabi a kalla burin inganta lafiya guda daya",
      "pickPrimary": "Da fatan za a zabi babban burin ka",
      "pickRegion": "Da fatan za a zabi yankin al'adun ka don ba ka shawarwarin abinci",
      "pickFocus": "Da fatan za a zabi fannin da ka fi son mayar da hankali akai"
    },
    "step1": {
      "title": "Bayananka Na Lafiya",
      "description": "Taimaka mana mu gina maka tsarin lafiya na musamman ta fasahar AI",
      "age": "Shekaru *",
      "agePlaceholder": "misali, 30",
      "height": "Tsayinka (cm) *",
      "heightPlaceholder": "misali, 170",
      "weight": "Nauyinka (kg) *",
      "weightPlaceholder": "misali, 70"
    },
    "step2": {
      "title": "Burinka Na Lafiya",
      "description": "Zabi dukkan abubuwan da kake bukata, sannan ka zabi babban burin ka guda daya",
      "primaryLabel": "Zabi Babban Burin Ka *",
      "primaryBadge": "Babban Buri"
    },
    "step3": {
      "title": "🌍 Al'ada da Sha'awar Abinci",
      "description": "Taimaka mana mu san nau'ikan abincin da suka dace da kai",
      "regionLabel": "Yankin Al'ada *",
      "regionHint": "Zabi asalin al'adun ka don samun shawarwarin abincin da ya dace da kai",
      "countryLabel": "Ƙasa (Idan akwai)",
      "countryPlaceholder": "misali, Nigeria, Kenya, Jamaica",
      "countryHint": "Don samun ingantattun shawarwari na musamman",
      "foodPrefLabel": "Irin Abincin Da Ka Fi Sha'awa"
    },
    "step4": {
      "title": "Babban Mayar da Hankali",
      "description": "Zabi fannin da kake son ingantawa sosai"
    },
    "step5": {
      "title": "Abubuwan Da Ka Fi So",
      "description": "Tsara yadda kake son HealthLoop ya gudanar da ayyukansa",
      "trackMeds": "Bibiyar Magunguna",
      "trackMedsHint": "Ba da damar tuna maka lokutan shan magani a kullum",
      "specialist": "Ina Sha'awar Shawarar Masana",
      "specialistHint": "Samun damar tuntubar masanan abinci da na lafiyar kwakwalwa",
      "confidentialTitle": "Tabbacin Sirri:",
      "confidentialBody": "Dukkan bayanan ka suna nan a killace, kuma ana amfani da su ne kawai don ba ka shawarwarin lafiya na musamman."
    },
    "step6": {
      "title": "Tsara Abinci",
      "description": "Taimaka mana mu ba ka shawarwarin abincin da ya dace da dandano da bukatun lafiyar ka",
      "cuisinesLabel": "Abincin Da Ka Fi So (Idan akwai)",
      "cuisinesHint": "Zabi nau'ikan abincin da ka fi sha'awa",
      "dietaryLabel": "Ƙuntatawa Kan Abinci (Idan akwai)",
      "dietaryHint": "Zabi dukkan wanda ya shafe ka",
      "allergiesLabel": "Abincin Da Ke Maka Illa (Idan akwai)",
      "allergiesHint": "Zabi abincin da jikinka ba ya so",
      "personalisedTitle": "Abinci Na Musamman:",
      "personalisedBody": "Zamu yi amfani da wadannan zabukan wajen ba ka shawarwarin abincin da kake so. Zaka iya canza su a kowane lokaci a cikin Saiti (Settings)."
    },
    "healthGoals": {
      "better_sleep": "Bacci Mai Kyau",
      "reduce_stress": "Rage Damuwa",
      "increase_energy": "Ƙarin Kuzari",
      "weight_management": "Kula da Nauyi",
      "improve_fitness": "Inganta Kuzari",
      "better_nutrition": "Ingantaccen Abinci",
      "mental_wellness": "Lafiyar Kwakwalwa",
      "chronic_condition": "Kula da Lafiya"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Lafiyar Kwakwalwa",
        "description": "Maida hankali kan yanayi, damuwa, da natsuwar zuciya"
      },
      "physical_fitness": {
        "label": "Motsa Jiki",
        "description": "Maida hankali kan motsa jiki da karfin jiki"
      },
      "nutrition": {
        "label": "Ingancin Abinci",
        "description": "Maida hankali kan cin abinci mai gina jiki"
      },
      "sleep": {
        "label": "Ingancin Bacci",
        "description": "Maida hankali kan hutu da samun isasshen bacci"
      },
      "stress_management": {
        "label": "Kula da Damuwa",
        "description": "Maida hankali kan natsuwa da rage nauyin rai"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Yammacin Afirka",
        "description": "Abincin Nigeria, Ghana, da Senegal"
      },
      "east_african": {
        "label": "Gabascin Afirka",
        "description": "Abincin Kenya, Ethiopia, da Tanzania"
      },
      "north_african": {
        "label": "Arewacin Afirka",
        "description": "Abincin Morocco da Egypt"
      },
      "southern_african": {
        "label": "Kudancin Afirka",
        "description": "Abincin South Africa"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Abincin Jamaica, Trinidad, da Barbados"
      },
      "middle_eastern": {
        "label": "Gabas ta Tsakiya",
        "description": "Abincin Lebanon, Palestine, da Syria"
      },
      "south_asian": {
        "label": "Kudancin Asiya",
        "description": "Abincin India, Pakistan, da Bangladesh"
      },
      "east_asian": {
        "label": "Gabashin Asiya",
        "description": "Abincin China, Japan, da Korea"
      },
      "southeast_asian": {
        "label": "Kudu maso Gabashin Asiya",
        "description": "Abincin Thailand, Vietnam, da Indonesia"
      },
      "western": {
        "label": "Yammacin Turai",
        "description": "Abincin Amurka da Turai"
      },
      "latin_american": {
        "label": "Latin Amurka",
        "description": "Abincin Mexico, Brazil, da Argentina"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Abincin Greece, Italy, da Spain"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Na Gargajiya",
        "description": "Mafi yawan abinci daga yankin al'adar ka"
      },
      "mixed": {
        "label": "Gauraye",
        "description": "Haɗin abincin gida da na ƙasashen waje"
      },
      "international": {
        "label": "Na Duniya",
        "description": "Nau'ikan abinci daban-daban na duniya"
      }
    },
    "cuisines": {
      "west_african": "Yammacin Afirka",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asiya",
      "western": "Yammacin Turai",
      "indian": "Indiya",
      "middle_eastern": "Gabas ta Tsakiya",
      "general": "Dukkan Abinci"
    },
    "dietary": {
      "vegetarian": "Masu Cin Ganye",
      "vegan": "Vegan",
      "pescatarian": "Masu Cin Kifi",
      "gluten_free": "Babu Gluten",
      "dairy_free": "Babu Madara",
      "low_carb": "Maras Nauyi"
    },
    "allergies": {
      "nuts": "Gyada/Gwaiduwa",
      "shellfish": "Abincin Ruwa",
      "dairy": "Madara",
      "eggs": "Kwai",
      "soy": "Waken Soya",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Abincin Nijeriya",
    "cuisine_ghanaian": "Abincin Ghana",
    "cuisine_senegalese": "Abincin Senegal",
    "cuisine_kenyan": "Abincin Kenya",
    "cuisine_ethiopian": "Abincin Habasha",
    "cuisine_moroccan": "Abincin Moroko",
    "cuisine_south_african": "Abincin Afirka ta Kudu",
    "cuisine_jamaican": "Abincin Jamaica",
    "cuisine_trinidadian": "Abincin Trinidad",
    "cuisine_lebanese": "Abincin Lebanon",
    "cuisine_turkish": "Abincin Turkiyya",
    "cuisine_greek": "Abincin Girka",
    "cuisine_italian": "Abincin Italiya",
    "cuisine_french": "Abincin Faransa",
    "cuisine_british": "Abincin Birtaniya",
    "cuisine_indian_south": "Abincin Kudancin Indiya",
    "cuisine_indian_north": "Abincin Arewacin Indiya",
    "cuisine_pakistani": "Abincin Pakistan",
    "cuisine_japanese": "Abincin Japan",
    "cuisine_chinese": "Abincin Sin",
    "cuisine_korean": "Abincin Koriya",
    "cuisine_vietnamese": "Abincin Vietnam",
    "cuisine_thai": "Abincin Thailand",
    "cuisine_filipino": "Abincin Philippines",
    "cuisine_american": "Abincin Amurka",
    "cuisine_mexican": "Abincin Mexico",
    "cuisine_brazilian": "Abincin Brazil",
    "cuisine_peruvian": "Abincin Peru"
  },
  "dashboard": {
    "welcome": "Barka da dawowa",
    "greeting": "Sannu",
    "goodMorning": "Ina kwana",
    "goodAfternoon": "Barka da yamma",
    "goodEvening": "Barka da dare",
    "tagline": "Ƙananan matakai na lafiya suna kawo canji mai dorewa",
    "microcopy": "Tafiyar lafiyarka tana da muhimmanci.",
    "welcomeSubtitleMorning1": "Fara ranar cikin natsuwa.",
    "welcomeSubtitleMorning2": "Muna farin cikin ganinka a wannan safiyar.",
    "welcomeSubtitleMorning3": "Ƙananan nasarori suna tara babban canji.",
    "welcomeSubtitleAfternoon1": "Muna fatan ranarka tana tafiya lafiya.",
    "welcomeSubtitleAfternoon2": "Barka da dawowa HealthLoop.",
    "welcomeSubtitleAfternoon3": "Huta ka ɗan shaki iska — kana ƙoƙari sosai.",
    "welcomeSubtitleEvening1": "Muna taya ka huta yanzu.",
    "welcomeSubtitleEvening2": "Kammala ranar cikin kwanciyar hankali.",
    "welcomeSubtitleEvening3": "Barka da dawowa a wannan daren.",
    "title": "Dandalin Basirar Rigakafin Lafiya",
    "subtitle": "Bibiyi lafiyarka, koya, sannan ka ɗauki mataki kafin matsala ta yi girma",
    "summary": "Takaitaccen Basirar Lafiyarka",
    "summaryDesc": "Sani na take a fannin rigakafi, ilimi, da inganta lafiya",
    "comprehensiveSupport": "Cikakken tallafi a bangaren rigakafi, ilimi, da jin daɗin rayuwa",
    "todayCheckIn": "Duban Lafiyar Yau",
    "quickActions": "Matakai Masu Sauri",
    "healthOverview": "Bayanin Lafiya",
    "recentActivity": "Ayyukan Kwanan Nan",
    "viewAll": "Duba Duka",
    "preventiveHealth": "Rigakafin Lafiya",
    "preventiveHealthDesc": "Bibiyar kullum, lura da lafiya & faɗakarwa",
    "education": "Ilimi",
    "educationDesc": "Bayanai bisa bincike, makalun lafiya & jagoran masana",
    "engagement": "Hulɗa",
    "engagementDesc": "Gasar al'umma, bibiyar hali & tallafin jama'a",
    "wellness": "Inganta Lafiya",
    "wellnessDesc": "Ingantaccen abinci, daidaita rayuwa & lafiyar jiki gaba ɗaya",
    "todaysInsight": "Sanin Yau",
    "wellnessScore": "Makin Lafiya",
    "healthStreak": "Jerin Kwanakin Lafiya",
    "days": "kwanaki",
    "logHealth": "Yi Rajistar Lafiya",
    "getEducated": "Nemi Ilimi",
    "communityChallenge": "Gasar Al'umma",
    "checkWellness": "Duba Lafiya",
    "verified": "An Tabbatar",
    "joinCommunity": "Shiga Al'umma",
    "personalizedPlan": "Tsarin da Ya Dace da Kai",
    "score": "Maki",
    "checkIns": "dubawa",
    "habits": "halaye",
    "preventive": "Rigakafi",
    "healthMetrics": "Ma'aunin Lafiya",
    "trackMetrics": "Bibiyi Ma'auni",
    "startTracking": "Fara bibiya",
    "logMetrics": "Shigar da Ma'auni",
    "dailyInsight": "Sanin Kullum",
    "learnAbout": "Koya game da rigakafin lafiya a yau",
    "articlesAvailable": "makalu akwai",
    "browseArticles": "Duba Makalu",
    "currentStreak": "Jerin Kwanaki Na Yanzu",
    "keepGoing": "Ci gaba da hakan!",
    "startStreak": "Fara jerenka na kwanaki",
    "checkIn": "Duba Lafiya",
    "nutritionPlan": "Tsarin Abinci",
    "mealsPlanned": "abincin da aka tsara",
    "viewPlan": "Duba Tsari",
    "planYourWeek": "Tsara makonku",
    "moodStress": "Yanayi & Damuwa",
    "howFeeling": "Yaya kake ji?",
    "logWellness": "Rijistar Lafiya",
    "medications": "Magunguna",
    "noMeds": "Ba a bibiyar kowane magani",
    "addMedications": "Ƙara magungunanka",
    "daysTracked": "Kwanakin da aka Bibiya",
    "noHabits": "Babu wasu halaye tukunna",
    "startTrackingHabits": "Fara bibiyar halaye",
    "insights": "Sani",
    "noInsights": "Babu sanin da aka samu tukunna",
    "completeFirstPlan": "Kammala tsarinka na farko",
    "noCheckIns": "Ba a yi duban lafiya ba tukunna",
    "startFirstCheckIn": "Fara duban lafiyarka na farko"
  },
  "support": {
    "title": "Taimako",
    "subtitle": "Nemi amsoshi, tuntuɓe mu, ko kai ƙarar wata matsala",
    "backToSettings": "Koma zuwa saituna",
    "privacyBanner": "Ana kula da buƙatun taimako cikin sirri. Bayanan lafiyarka suna nan a kiyaye.",
    "section1": "Sashi na 1",
    "section2": "Sashi na 2",
    "section3": "Sashi na 3",
    "section4": "Sashi na 4",
    "navHelpCenter": "Cibiyar Taimako",
    "navContact": "Tuntuɓi Taimako",
    "navHealth": "Ayyukan Lafiya",
    "navTechnical": "Taimakon Fasaha",
    "helpCenterTitle": "Cibiyar Taimako",
    "helpCenterSubtitle": "Nemi tambayoyin da aka fi yi don samun amsoshi da sauri.",
    "contactTitle": "Tuntuɓi Taimako",
    "contactSubtitle": "Yi magana da rukuninmu ta hanyar da ka fi so.",
    "healthServicesTitle": "Ayyukan Lafiya",
    "healthServicesSubtitle": "Haɗu da masu bibiyar magunguna da ƙwararrun likitoci.",
    "technicalTitle": "Taimakon Fasaha",
    "technicalSubtitle": "Kai ƙarar kura-kurai ko matsalolin fasaha tare da cikakken bayani.",
    "searchPlaceholder": "Nemi tambayoyin da aka fi yi…",
    "liveChat": "Hirar kai-tsaye",
    "emailUs": "Turo Mana Imel",
    "callBack": "Tsara lokacin kira",
    "sendMessage": "Aika saƙo",
    "medicationTracking": "Bibiyar magunguna",
    "specialistAccess": "Samun masana",
    "videoConsultation": "Tuntuɓar juna ta bidiyo",
    "reportBug": "Kai ƙarar kuskure",
    "yourName": "Sunanka",
    "yourEmail": "Imel ɗinka",
    "subject": "Batun saƙo",
    "message": "Saƙo",
    "phone": "Wayar tarho",
    "description": "Bayanin matsala",
    "submit": "Aika",
    "successTitle": "An aika saƙo",
    "successDescription": "Zamu ba ka amsa cikin sa'o'i 24–48.",
    "healthDisclaimer": "Don matsalolin gaggawa, tuntuɓi hukumomin gaggawa na kusa. HealthLoop ba madadin kulawar likita ba ne."
  },
  "nutrition": {
    "smartNutrition": "Ingantaccen Abinci",
    "basedOnGoal": "Bisa ga burinka:",
    "personalizedData": "An tsara shi ne bisa bayanan lafiyarka na kwanan nan",
    "evidenceBased": "Abinci bisa bincike a matsayin wani ɓangare na rigakafin lafiyarka",
    "todaysMealSuggestions": "Shawarwarin Abinci Na Yau",
    "customize": "Gyara yadda kake so",
    "breakfast": "Karin Kumallo",
    "lunch": "Abincin Rana",
    "dinner": "Abincin Dare",
    "loadingBreakfast": "Ana loding karin kumallo...",
    "loadingLunch": "Ana loding abincin rana...",
    "loadingDinner": "Ana loding abincin dare...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Canja Abinci",
    "healthyOptionsNearYou": "Abinci Masu Kyau Kusa Da Kai",
    "enableLocation": "Bada izinin gano wuri",
    "view": "Duba",
    "discoverOptions": "Nemi gidajen abinci masu kyau, shaguna, da masu abincin kusa da kai",
    "cuisinesSelected": "nau'in abinci aka zaɓa",
    "cuisineSelected": "nau'in abinci aka zaɓa",
    "dietaryPrefs": "sha'awar abinci",
    "dietaryPref": "sha'awar abinci",
    "customizeMeals": "Gyara Abinci",
    "subtitleAdaptive": "Tsarin abinci da ya dace da al'ada da burin lafiyarka",
    "hideFavorites": "Ɓoye Abubuwan So",
    "viewFavorites": "Duba Abubuwan So",
    "customizeMealsLegacy": "Daidaita abinci yadda zai dace da al'adarka da buƙatunka",
    "viewFullPlan": "Duba Cikakken Tsari",
    "exploreRecipes": "Duba Hanyoyin Girki"
  },
  "location": {
    "permissionTitle": "Nemi abinci masu kyau kusa da kai",
    "permissionDesc": "Ana amfani da wannan ne don nuna maka gidajen abinci da shagunan da suka dace da burin lafiyarka.",
    "howToEnable": "Yadda za a ba da izini:",
    "step1": "Danna alamar kwaɗo 🔒 a saman mashigar intanet ɗinka",
    "step2": "Nemi izinin \"Location\"",
    "step3": "Canja shi zuwa \"Allow\"",
    "step4": "Sake buɗe wannan shafin",
    "refreshPage": "Sake Buɗe Shafi",
    "allowLocation": "Bada Izini",
    "notNow": "Ba yanzu ba",
    "denied": "An hana izinin gano wuri. Don ganin abinci kusa da kai, kana bukatar bada izini.",
    "unavailable": "Bayanin wurin da kake ba ya samuwa a halin yanzu. Da fatan za ka duba saitunan na'urarka.",
    "error": "Ba a iya gano wurin da kake ba. Sake gwadawa ko duba saitunan intanet.",
    "unsupported": "Wannan intanet ɗin ba ta goyon bayan gano wuri. Gwadawa da Chrome, Firefox, ko Safari.",
    "accessRequired": "Ana Buƙatar Izinin Gano Wuri"
  },
  "womensHealth": {
    "title": "Lafiyar Mata",
    "description": "Bibiyi jinin al'ada, yi rajistar alamun jiki, sannan ka sami shawarwarin lafiya",
    "cycleTracking": "Bibiyar Lokacin Al'ada",
    "symptomLogging": "Rijistar Alamun Jiki",
    "phaseInsights": "Sani kan Yanayin Jiki",
    "logPeriod": "Shigar da Kwanakin Al'ada",
    "logSymptoms": "Shigar da Alamun Jiki",
    "insights": "Sani",
    "tips": "Shawarwarin Lafiya",
    "overview": "Bayanai Gaba ɗaya",
    "history": "Tarihi",
    "startTracking": "Fara Bibiyar Al'adarka"
  },
  "profile": {
    "title": "Bayanai",
    "personalInfo": "Bayananka na Sirri",
    "healthProfile": "Bayanin Lafiya",
    "preferences": "Zaɓuka",
    "language": "Harshe",
    "selectLanguage": "Zaɓi Harshe",
    "notifications": "Sanarwa",
    "privacy": "Sirri",
    "security": "Tsaro",
    "quickAccess": "Shiga Cikin Sauri",
    "editProfile": "Gyara Bayanai",
    "viewStats": "Duba Kididdiga",
    "backToDashboard": "Koma Gidan Yanar Gizo",
    "womensHealthTitle": "Lafiyar Mata",
    "womensHealthDesc": "Bibiyar al'ada, alamu & shawarwarin lafiya",
    "healthRemindersTitle": "Tunasarwar Lafiya",
    "healthRemindersDesc": "Kula da sanarwarku",
    "manageRemindersDesc": "Kula da yadda kake son a rika tunatar da kai",
    "healthPatternAlerts": "Faɗakarwa kan Yanayin Lafiyarka",
    "supportHelp": "Taimako",
    "supportHelpDesc": "Nemi taimako, kai ƙara, ko duba tambayoyi",
    "admin": "Admin",
    "adminDesc": "Duba yadda ake amfani da manhajar",
    "giveFeedback": "Ba da Sharhi",
    "giveFeedbackDesc": "Faɗi ra'ayinka game da HealthLoop",
    "reportProblem": "Kai Ƙarar Matsala",
    "reportProblemDesc": "Taimake mu gyara kura-kurai don inganta manhajar",
    "manageHealthInfo": "Kula da bayanan rigakafin lafiyarka don samun shawarwarin da suka dace",
    "basicInformation": "Bayanai na Asali",
    "fullName": "Cikakken Suna",
    "email": "Imel",
    "dateOfBirth": "Ranar Haihuwa",
    "gender": "Jinsi",
    "height": "Tsayi (cm)",
    "weight": "Nauyi (kg)",
    "medicalConditions": "Yanayin Lafiya",
    "allergies": "Abubuwan da Ba Su Haɗiye Da Jiki",
    "personalHealth": "Lafiyar Kai",
    "addCondition": "Ƙara yanayin lafiya",
    "addAllergy": "Ƙara abin da ba ya haɗiye da jiki",
    "saveChanges": "Ajiye Canje-canje",
    "saving": "Ana ajiyewa...",
    "privacyMessage": "An kiyaye bayanan lafiyarka tare da cikakken tsaro"
  },
  "settings": {
    "title": "Saituna",
    "general": "Gabaɗaya",
    "account": "Asusu",
    "appearance": "Siffar manhaja",
    "languageSettings": "Saitun harshe",
    "changeLanguage": "Canza harshe",
    "languageNote": "Fuskancewar aikace-aikacen tana canzawa nan take da zarar ka zaɓi sabon yare. Harsunan Afirka da sababbin harsuna an yi musu alamar 'Starter' — fassarar na’ura ce don faɗaɗa amfani, muna jiran bita daga masu yaren asali.",
    "languageUpdated": "An yi nasarar sabunta harshe",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Fassarar na’ura — ana jiran bita daga mai yaren asali.",
    "regions": {
      "global": "Duniya Baki Ɗaya",
      "european": "Harsunan Turai",
      "middleEastern": "Harsunan Gabas ta Tsakiya",
      "asian": "Harsunan Asiya",
      "african": "Harsunan Afirka"
    }
  },
  "search": {
    "triggerLabel": "Bincika HealthLoop",
    "triggerHint": "Gwada rubuta \"taki\", \"kemis\" ko \"juna biyu\"",
    "triggerAriaLabel": "Bude gurin bincike",
    "placeholder": "Nemi abubuwan morewa, tracker, taimako...",
    "inputAriaLabel": "Bincika abubuwan morewa na HealthLoop",
    "modalAriaLabel": "Bincika HealthLoop",
    "close": "Rufe",
    "clear": "Goge",
    "clearAriaLabel": "Goge bincike",
    "recentSearches": "Binciken baya-bayan nan",
    "tryFor": "Gwada bincika",
    "findFeatures": "Nemo kowane sashe cikin dakiku kalilan.",
    "searchAcross": "Bincika a ko'ina a",
    "and": "da",
    "sections": {
      "home": "Gida",
      "nutrition": "Abinci mai gina jiki",
      "family": "Iyali",
      "services": "Ayyuka",
      "support": "Taimako",
      "profile": "Bayananka"
    },
    "noMatchesFor": "Ba a sami sakamako ga \"{{query}}\" ba",
    "trySimpler": "Gwada amfani da kalmomi masu sauki kamar taki, abinci, ko likita.",
    "comingSoonBadge": "Yana nan tafe",
    "escToClose": "domin rufewa",
    "resultSingular": "Sakamako {{count}}",
    "resultPlural": "Sakamako {{count}}",
    "searchAcrossApp": "Bincika cikin daukacin manhajar"
  },
  "familyMember": {
    "confirmRemove": "Kana son cire {{name}} daga lura da lafiyar iyali?",
    "removed": "An cire {{name}} daga iyali",
    "removeFailed": "An kasa cire mamban",
    "viewDetails": "Duba Karin Bayani",
    "edit": "Gyara",
    "remove": "Cire",
    "yearsSuffix": "shekaru",
    "healthGoalsLabel": "Burin Lafiya:",
    "moreSuffix": "kari",
    "activeInsights": "Shawarwari Masu Amfani",
    "viewAllInsights": "Duba dukkan shawarwari {{count}} →",
    "viewFullProfile": "Duba Cikakkun Bayanan Lafiya",
    "lifeStage": {
      "infant": "Jariri (0-2)",
      "toddler": "Dan koyon tafiya (2-5)",
      "child": "Yaro (6-12)",
      "adolescent": "Matashi (13-17)",
      "adult": "Babba (18-59)",
      "senior": "Tsoho (60+)",
      "unknown": "Ba a sani ba"
    }
  },
  "profileDeep": {
    "backToDashboard": "Koma babban shafi",
    "profileCompletion": "Kammala bayanan asusu",
    "healthSummary": "Takaitaccen bayanin lafiya",
    "sectionA": "Sashe na A",
    "sectionB": "Sashe na B",
    "sectionC": "Sashe na C",
    "sectionD": "Sashe na D",
    "personalDetails": "Bayanan kai",
    "healthInformation": "Bayanin lafiya",
    "accountSettings": "Saitunan asusu",
    "fullName": "Cikakken suna",
    "email": "Imel",
    "dob": "Ranar haihuwa",
    "gender": "Jinsi",
    "genderPlaceholder": "misali, Mace, Namiji",
    "height": "Tsawo (cm)",
    "heightPlaceholder": "misali, 170",
    "weight": "Nauyi (kg)",
    "weightPlaceholder": "misali, 70",
    "allergies": "Abubuwan da ba sa karɓar jikinka",
    "allergiesPlaceholder": "misali, Gyada",
    "medicalConditions": "Yanayin lafiya",
    "conditionsPlaceholder": "misali, Hawan jini",
    "medications": "Magunguna",
    "medicationsPlaceholder": "misali, Lisinopril 10mg, kullum",
    "emergencyContact": "Lambar gaggawa",
    "emergencyOptional": "(idan kana so)",
    "emergencyPlaceholder": "misali, Mahaifiya +234...",
    "emergencyNote": "Ana nuna wannan ne kawai ga mai ba da shawarar lafiya idan ka amince.",
    "saveChanges": "Ajiye canje-canje",
    "saving": "Ana ajiye wa...",
    "editProfile": "Gyara bayanan asusu",
    "cancelEditing": "Soke gyara",
    "healthScore": "Makin lafiya",
    "streak": "Dogon zango",
    "streakDays": "Kwanaki {{n}}",
    "memberSince": "Ya shiga tun",
    "remindersActive": "Tuna-da-kai yana kunne",
    "conditionsTracked": "Yanayin da ake bibiya",
    "nextAgenda": "Abin yi na gaba",
    "notificationsReminders": "Sanarwa da tuna-da-kai",
    "notificationsRemindersDesc": "Saita lokutan tuna-da-kai na lafiya",
    "emailNudges": "Sakonni ta imel",
    "emailNudgesDesc": "Tuna-da-kai a hankali da taƙaitaccen bayanin mako",
    "on": "Kunne",
    "paused": "An dakatar",
    "privacySecurity": "Sirri da tsaro",
    "privacySecurityDesc": "Sabunta kalmar sirri don kare asusunka",
    "preferencesTitle": "Zabuka",
    "preferencesDesc": "Harshe, yanki, da sauran saituna",
    "supportHelp": "Taimako",
    "supportHelpDesc": "Samun amsoshi da tuntuɓarmu",
    "giveFeedback": "Ba da ra'ayi",
    "giveFeedbackDesc": "Gaya mana abin da ya kamata mu gyara",
    "reportProblem": "Kai karar matsala",
    "reportProblemDesc": "Ka ga kuskure? Sanar da mu",
    "adminInsights": "Bayanin admin",
    "adminInsightsDesc": "Kididdigar amfani",
    "adminBadge": "Admin",
    "shareWithClinician": "Raba bayani da mai ba da shawara",
    "shareWithClinicianDesc": "Takaitaccen bayani kawai · yana karewa kai tsaye · za ka iya soke shi kowane lokaci",
    "share": "Raba",
    "profileMayBeOutOfDate": "Bayanan asusu na iya buƙatar sabuntawa",
    "profileMayBeOutOfDateDesc": "Tabbatar bayanan lafiyarka na daidai ne don samun ingantacciyar jagora — koda ƙananan canje-canje ne (nauyi, magunguna) suna taimaka mana wajen turo maka sakonni da suka dace.",
    "updateNow": "Sabunta yanzu",
    "profileUpdateError": "Ba a iya sabunta abin da ka zaɓa ba. Da fatan za a sake gwadawa.",
    "healthLoopUser": "Mai amfani da HealthLoop",
    "updatedLabel": "An sabunta",
    "noEntries": "Babu bayanan tukuna.",
    "completionComplete": "An kammala bayanan asusunka. Yanzu za mu iya ba ka mafi kyawun jagora. 💚",
    "completionAlmostThere": "An kusa gamawa. Karin wasu bayanan kaɗan za su ba ka damar samun ƙarin haske.",
    "completionInProgress": "Kammala bayanan asusunka don samun ingantaccen jagorar rayuwa.",
    "justNow": "yanzun nan",
    "minAgo": "minti {{n}} da ya wuce",
    "minsAgo": "minti {{n}} da suka wuce",
    "hourAgo": "awa {{n}} da ya wuce",
    "hoursAgo": "awa {{n}} da suka wuce",
    "dayAgo": "kwana {{n}} da ya wuce",
    "daysAgo": "kwanaki {{n}} da suka wuce",
    "checkinDueToday": "Duban lafiya na yau ya nuna",
    "checkinDueTonight": "Duban lafiya na daren nan ya nuna"
  },
  "supportDeep": {
    "backToSettings": "Koma saituna",
    "quickNavAria": "Sassan taimako",
    "searchPlaceholder": "Nemi taimako...",
    "searchAria": "Nemi tambayoyin da aka fi yi",
    "resultsCount": "sakamako {{n}}",
    "resultsCountPlural": "sakamako {{n}}",
    "questionsCount": "tambayoyi {{n}}",
    "liveChatTitle": "Tattaunawa kai tsaye",
    "liveChatDesc": "Yi magana da mu kai tsaye · Lit-Jum 9am–6pm",
    "startChat": "Fara tattaunawa",
    "liveChatSoonToast": "Tattaunawa kai tsaye tana nan tafe. Kafin nan, za ka iya turo mana imel.",
    "emailUsTitle": "Turo mana imel",
    "emailUsDesc": "Za mu ba da amsa a tsakanin awa 24–48",
    "copy": "Kwafa",
    "emailCopied": "An kwafi adireshin imel.",
    "contactFormTitle": "Fom ɗin tuntuɓa",
    "contactFormDesc": "Turo mana sako — za mu ba ka amsa ta imel.",
    "yourNameLabel": "Sunanka *",
    "namePlaceholder": "Audu Bello",
    "yourEmailLabel": "Imel ɗinka *",
    "emailPlaceholder": "audu@example.com",
    "subjectOptional": "Maudu'i (idan kana so)",
    "subjectPlaceholder": "Me kake buƙatar taimako a kai?",
    "messageLabel": "Sako *",
    "messagePlaceholder": "Gaya mana takaitaccen abin da kake buƙata.",
    "sending": "Ana tura wa...",
    "sendMessage": "Tura sako",
    "messageSent": "An tura sako",
    "messageSentDesc": "Za mu ba da amsa a tsakanin awa 24–48.",
    "callbackTitle": "Nemi a kira ka",
    "callbackDesc": "Za mu kira ka a lokacin da ya dace da kai.",
    "phoneLabel": "Lambar waya *",
    "phonePlaceholder": "+234...",
    "preferredTimeLabel": "Lokacin da ka fi so (idan kana so)",
    "preferredTimePlaceholder": "misali gobe da yamma",
    "reasonLabel": "Dalili (idan kana so)",
    "reasonPlaceholder": "A taƙaice, me kake son mu tattauna?",
    "submitting": "Ana tura wa...",
    "requestCallback": "Nemi a kira ka",
    "callbackRequested": "An nemi a kira ka",
    "callbackRequestedDesc": "Za mu tuntuɓe ka a cikin awa 24.",
    "medicationSupport": "Taimakon magani",
    "medicationSupportDesc": "Biyun takardun magani da tuna-da-kai.",
    "goToMedications": "Je zuwa sashin magunguna →",
    "specialistConsultation": "Shawarar ƙwararre",
    "specialistConsultationDesc": "Tuntubi mai ba da shawarar lafiya don samun jagora.",
    "connectExpert": "Yi magana da ƙwararre →",
    "videoConsult": "Tattaunawa ta bidiyo",
    "videoConsultDesc": "Yi ajiyar lokacin ganawa da ƙwararre ta bidiyo.",
    "bookConsultation": "Yi ajiyar tattaunawa →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop tana taimaka maka wajen inganta lafiyarka ta yau da kullun — ba ta maye gurbin kulawar likita na gaggawa ba. Idan akwai matsalar gaggawa, tuntuɓi asibiti mafi kusa.",
    "categoryLabel": "Nau'i",
    "catBug": "Kuskure / Matsala",
    "catPerformance": "Gudu ya ragu",
    "catFeature": "Wani abu ba ya aiki",
    "catUi": "Matsalar nunawa",
    "catOther": "Wasu daban",
    "issueTitle": "Maudu'in matsalar *",
    "issueTitlePlaceholder": "Takaitaccen bayani",
    "detailedDescription": "Cikakken bayani *",
    "detailedDescriptionPlaceholder": "Me ya faru? Me kake yi lokacin da hakan ya faru? Bayyana mana matakan da ka bi zai taimaka sosai.",
    "autoAttachNote": "Ana tura bayanan na'urarka da burauza kai tsaye.",
    "submitReport": "Tura rahoton matsala",
    "reportSubmitted": "An tura rahoton",
    "reportSubmittedDesc": "Tawagarmu tana duba matsalar.",
    "fillAllFields": "Da fatan za a cika dukkan wuraren da ake bukata",
    "problemReportSubmittedToast": "An tura rahoton matsala. Za mu bincika sannan mu sanar da kai.",
    "messageSentToast": "An tura sako. Za mu ba ka amsa a cikin awa 24–48.",
    "callRequestedToast": "An karɓi bukatar kiran waya. Za mu tuntuɓe ka a cikin awa 24.",
    "submitFailGeneric": "Ba a iya tura wa ba. Sake gwadawa ko ka turo imel zuwa {{email}}.",
    "submitFailContact": "Ba a iya tura wa ba. Da fatan za a turo imel zuwa {{email}} kai tsaye.",
    "comingSoon": "Nan Ba Da Jimawa Ba",
    "specialistRoadmapTitle": "Yi magana da ƙwararre",
    "specialistRoadmapSubtitle": "Jagora daga mutum tana nan tafe. Waɗannan ayyukan za su zauna a nan don sauƙin samu.",
    "talkToSpecialistTitle": "Yi magana da ƙwararre",
    "talkToSpecialistDesc": "Tattaunawa kai tsaye da ƙwararrun lafiya don tambayoyin yau da kullun.",
    "bookSpecialistTitle": "Nemi lokacin ganawa",
    "bookSpecialistDesc": "Tsara lokaci don tattaunawa 1:1 da ƙwararren da ya dace da burinka.",
    "liveHealthGuidanceTitle": "Jagoran lafiya kai tsaye",
    "liveHealthGuidanceDesc": "Samun jagora ta bidiyo game da alamu, sakamakon gwaje-gwaje, ko shirin kulawa.",
    "mentalWellnessTitle": "Taimakon kwanciyar hankali",
    "mentalWellnessDesc": "Taimakon sirri daga ƙwararrun lafiyar ƙwaƙwalwa lokacin da rayuwa ta yi nauyi.",
    "wellnessNavigationTitle": "Jagoran hanyoyin lafiya",
    "wellnessNavigationDesc": "Jagora mataki-mataki wanda zai taimake ka zaɓi mataki na gaba da ya dace.",
    "pharmacyRoadmapTitle": "Taimakon magani da kantin magani",
    "pharmacyRoadmapSubtitle": "Taimako game da kantin magani yana cikin sashin Taimako — babu sauran wani sabon wuri.",
    "medicationGuidanceTitle": "Jagoran magunguna",
    "medicationGuidanceDesc": "Jagora mai sauƙin fahimta kan yadda ake sha, lokaci, da haɗarin haɗa magunguna.",
    "findNearbyPharmacyTitle": "Nemo kantin magani mafi kusa",
    "findNearbyPharmacyDesc": "Nemo amintattun shagunan magani a yankinka cikin sauri.",
    "refillReminderTitle": "Tuna sabunta magani",
    "refillReminderDesc": "Tuna-da-kai a hankali domin kada magungunanka masu mahimmanci su ƙare.",
    "otcWellnessTitle": "Shawarar magungunan kanti",
    "otcWellnessDesc": "Jagora kan zabar amintattun magunguna da ake siya ba tare da takardar likita ba."
  },
  "careServices": {
    "pageTitle": "Ayyukan kulawa",
    "pageSubtitle": "Taimakon lafiya da aka tsara don tafiyar lafiyarka ta yau da kullun.",
    "specialistCareTitle": "Kulawar ƙwararru",
    "specialistCareSubtitle": "Yi magana da ƙwararru sannan ka tsara ganawa da su lokacin da kake bukata.",
    "medicationPharmacyTitle": "Magunguna da kantin magani",
    "medicationPharmacySubtitle": "Jagorar magani mai sauƙi da taimakon kantin magani.",
    "wellnessSupportTitle": "Taimakon rayuwa mai kyau",
    "wellnessSupportSubtitle": "Kwanciyar hankali, shawarar magunguna, da matakai na gaba.",
    "futureWellnessTitle": "Ayyuka masu zuwa",
    "futureWellnessSubtitle": "Samfofin abubuwan da HealthLoop za ta kawo a nan gaba.",
    "futureFeatureBadge": "Sabon siffa",
    "futurePersonalizedMealsTitle": "Shirin abinci na musamman",
    "futurePersonalizedMealsDesc": "Shirin abinci da aka tsara don burinka, abubuwan da ba sa karɓar jikinka, da al'adarka.",
    "futureHealthyDeliveryTitle": "Odar abinci mai lafiya",
    "futureHealthyDeliveryDesc": "Odar abinci daga wuraren girki da abokan hulɗa masu kula da lafiya.",
    "futureFarmFreshTitle": "Abinci sabo daga gona",
    "futureFarmFreshDesc": "Samun abinci kai tsaye daga gonakin karkara da abokan hulɗa na ganyaye.",
    "futureFoodPartnershipsTitle": "Haɗin gwiwar abinci",
    "futureFoodPartnershipsDesc": "Haɗin gwiwa da wuraren cin abinci, shaguna, da kamfanoni masu inganta lafiya.",
    "futureNutritionCoachingTitle": "Horar da abinci mai gina jiki",
    "futureNutritionCoachingDesc": "Jagora ɗaya-da-ɗaya daga ƙwararrun masana abinci mai gina jiki.",
    "futureFamilyWellnessTitle": "Shirye-shiryen lafiyar iyali",
    "futureFamilyWellnessDesc": "Shirye-shiryen da za su taimaka wa dukkan gidan su kasance cikin koshin lafiya.",
    "futureWellnessPlusTitle": "Membobin Wellness+",
    "futureWellnessPlusDesc": "Babban matsayi don samun jagora na musamman da ƙarin haske mai zurfi.",
    "futurePharmacyPartnersTitle": "Haɗin gwiwar kantin magani",
    "futurePharmacyPartnersDesc": "Haɗin gwiwa da amintattun shagunan magani don jagora da samun magunguna.",
    "futureAdvancedSpecialistTitle": "Kulawar ƙwararru na gaba",
    "futureAdvancedSpecialistDesc": "Hanyoyin samun ƙarin shawarwarin ƙwararru cikin sauƙi.",
    "futureWellnessMarketplaceTitle": "Kasuwar lafiya",
    "futureWellnessMarketplaceDesc": "Kasuwar da aka tace don sayan kayayyakin inganta lafiya.",
    "futureVendorCollabTitle": "Tsarin haɗin gwiwa",
    "futureVendorCollabDesc": "Tsarin tantance ingancin masu samar da abinci da sauran abokan hulɗa."
  },
  "dashboardDeep": {
    "healthProfile": "Bayanin lafiya",
    "notifications": "Sanarwa",
    "familyAccounts": "Asusun iyali",
    "settings": "Saituna",
    "logout": "Fita",
    "allCaughtUp": "Komai yana daidai.",
    "weekInReview": "Taƙaitaccen makonka",
    "dismissNotification": "Cire sanarwa",
    "dismissWeeklyDigest": "Cire taƙaitaccen mako",
    "notificationsAria": "Sanarwa",
    "profileMenuAria": "Bude menu na asusu",
    "loadingWellness": "Ana loda taƙaitaccen lafiyarka",
    "nextTip": "Shawara ta gaba",
    "todayAtGlance": "Abubuwan yau",
    "healthScoreLabel": "Makin lafiya",
    "currentStreakLabel": "Dogon zango yanzu",
    "todaysProgress": "Ci gaban yau",
    "insightForYou": "Haske a gare ka",
    "checkMyHealthRisk": "Duba kasadar lafiyata",
    "quickAccess": "Hanyar gaggawa",
    "exploreCareServicesTitle": "Bincika ayyukan kulawa",
    "exploreCareServicesSubtitle": "Kulawar ƙwararru · kantin magani · lafiya — duk a wuri ɗaya.",
    "familyCare": "Kulawar iyali",
    "healthLibrary": "Laburaren lafiya",
    "myHealthData": "Bayanan lafiyata",
    "askQuestion": "Yi tambaya",
    "dashLoadError": "Ba a iya loda shafin ba. Sake gwadawa.",
    "taskUpdateError": "Ba a iya sabunta aiki ba. Sake gwadawa.",
    "perfectDay": "Ranar murna! 🎉 Dogon zango ya ƙaru.",
    "letsStart": "Bari mu fara",
    "yourNextStepToday": "Matakinka na gaba a yau",
    "completeDailyCheck": "Kammala duban lafiyarka na kullum",
    "startDailyCheck": "Fara duban kullum",
    "viewAll": "Duba duka",
    "graceProtected": "An kiyaye",
    "todaysHealthRecommendations": "Shawarwarin lafiya na yau",
    "updateViaCheck": "Sabunta ta duban kullum",
    "healthInsight": "Hasken lafiya",
    "riskCheckSubtext": "Samun bayanin lafiya cikin sakanni",
    "foodDiet": "Abinci",
    "healthScoreNew": "Makin lafiya · Sabo",
    "letsBuildScore": "Bari mu gina makin lafiyarka tare",
    "oneHealthyHabitAtATime": "Dabi'a ɗaya mai kyau a kowane lokaci.",
    "nextCheck": "Dubawa ta gaba:",
    "todayAt8pm": "yau da ƙarfe 8:00 na dare",
    "wellnessTipForYou": "Shawarar lafiya ta yau · Gare ka",
    "wellnessTipForFactor": "Shawarar lafiya ta yau · Game da {{factor}}",
    "logged": "An yi rikodin",
    "gotIt": "Na gane 👍",
    "gladToSeeYou": "Muna farin cikin ganinka yau 💚",
    "takesLessThan60Sec": "Yana ɗaukar ƙasa da sakan 60",
    "scoreReadyWhenYou": "Mun shirya a duk lokacin da kake bukata",
    "scoreCompleteFirstCheck": "Kammala duban lafiyarka na farko don samun bayanan sirri.",
    "scoreExcellent": "Kyau kwarai",
    "scoreSupportExcellent": "Kana cikin yanayi mai kyau yau. Ci gaba da haka.",
    "scoreGood": "Yana da kyau",
    "scoreSupportGood": "Kana kokari. Ci gaba da kyawawan dabi'unka.",
    "scoreModerate": "Tsaka-tsaki",
    "scoreSupportModerate": "Kana daidai, amma akwai wasu wurare da ke bukatar kulawa.",
    "scoreNeedsAttention": "Yana bukatar kulawa",
    "scoreSupportNeedsAttention": "Lafiyarka na bukatar kulawa yau. Ƙananan canje-canje za su taimaka."
  },
  "emailVerify": {
    "bannerWithEmail": "Da fatan za a tabbatar da imel ɗinka ({{email}}) don mu kare asusunka sannan mu rinka turo maka sakonni na yau da kullun.",
    "bannerNoEmail": "Da fatan za a tabbatar da imel ɗinka don mu kare asusunka sannan mu rinka turo maka sakonni na yau da kullun.",
    "sending": "Ana tura wa...",
    "resend": "Sake tura imel",
    "sentToast": "An tura imel ɗin tabbatarwa. Duba akwatin sako.",
    "sendFailToast": "Ba a iya tura imel ɗin tabbatarwa ba. Sake gwadawa daga baya."
  },
  "forgotPassword": {
    "title": "Ka manta kalmar sirri?",
    "subtitle": "Kada ka damu! Shigar da imel ɗinka za mu turo maka hanyar canzawa.",
    "emailLabel": "Adireshin imel",
    "emailPlaceholder": "sunanka@example.com",
    "sendResetLink": "Tura hanyar canzawa",
    "sending": "Ana tura wa...",
    "backToLogin": "Koma wurin shiga",
    "resendLink": "Sake tura imel",
    "successTitle": "Duba imel ɗinka",
    "successBody": "Idan akwai asusu mai suna {{email}}, mun turo da hanyar canza kalmar sirri.",
    "linkExpires": "Wannan hanyar za ta daina aiki cikin minti 30.",
    "successToast": "Duba imel ɗinka don ganin yadda zaka canza kalmar sirri",
    "errEmptyEmail": "Da fatan za a shigar da adireshin imel",
    "errInvalidEmail": "Shigar da ingantaccen adireshin imel",
    "errNetwork": "Ba a iya samun uwar garken ba. Duba intanet ɗinka.",
    "errGeneric": "Ba a iya tura imel ɗin ba. Sake gwadawa ko tuntuɓi taimako."
  },
  "resetPassword": {
    "title": "Saita sabon kalmar sirri",
    "subtitle": "Ƙirƙiri kalmar sirri mai ƙarfi don asusunka",
    "newPasswordLabel": "Sabon kalmar sirri",
    "newPasswordPlaceholder": "Shigar da sabon kalmar sirri",
    "confirmPasswordLabel": "Tabbatar da kalmar sirri",
    "confirmPasswordPlaceholder": "Sake shigar da sabon kalmar sirri",
    "requirementsHint": "Dole ne ya kasance aƙalla haruffa 8, da babban harafi, ƙaramin harafi, da lamba",
    "resetPassword": "Canza kalmar sirri",
    "resetting": "Ana canzawa...",
    "successTitle": "An canza kalmar sirri cikin nasara!",
    "successBody": "Yanzu za ka iya shiga asusunka da sabon kalmar sirri.",
    "successToast": "An canza kalmar sirri!",
    "goToLogin": "Je zuwa wurin shiga",
    "invalidLinkTitle": "Hanyar canzawa ba ta da kyau",
    "invalidLinkBody": "Wannan hanyar canza kalmar sirri ba ta da kyau ko kuma lokacinta ya wuce.",
    "requestNewLink": "Nemi sabuwar hanya",
    "showPassword": "Nuna kalmar sirri",
    "hidePassword": "Ɓoye kalmar sirri",
    "errInvalidLink": "Hanyar canzawa ba ta da kyau",
    "errMismatch": "Kalmomin sirri ba su yi daidai ba",
    "errTooShort": "Kalmar sirri ya kamata ya kai aƙalla haruffa 8",
    "errExpiredToken": "Wannan hanyar ta daina aiki. Da fatan za a nemi sabuwa.",
    "errNetwork": "Ba a iya samun uwar garken ba. Duba intanet ɗinka.",
    "errGeneric": "An kasa canza kalmar sirri. Sake gwadawa."
  },
  "tips": {
    "water1": "Shan ruwa a tsakanin minti 30 bayan tashi daga barci yana ƙara wa jiki kuzari.",
    "water2": "Shan kofin ruwa kafin kowane abinci hanya ce mai kyau ta kiyaye ƙishirwa.",
    "water3": "Sa yanki na lemun tsami ko ganyen na'a-na'a a cikin ruwa yana sa shan ruwan daɗi.",
    "meals1": "Ƙara kayan lambu a abincinka na yau da kullun yana taimaka wa zuciya da hanji.",
    "meals2": "Cin ƙwayoyin itatuwa (nuts) da safe yana sa kuzarinka ya dore har rana ta tafi.",
    "meals3": "Cin 'ya'yan itace kai tsaye ya fi shan ruwansu (juice) — domin yana ɗauke da sinadarin fiber.",
    "steps1": "Yin tafiya na minti 10 bayan cin abinci yana taimaka wa jikinka narkar da sukari.",
    "steps2": "Miko jiki (stretch) na minti 5 da safe yana rage fargaba da sa natsuwa.",
    "steps3": "Hawa matakala koda sau ɗaya a rana yana ƙarfafa zuciya cikin lokaci.",
    "sleep1": "Rage hasken fitila sa'a ɗaya kafin barci yana taimaka wa jiki ya huta don barci mai daɗi.",
    "sleep2": "Samun lokaci ɗaya na tashi daga barci — koda a ƙarshen mako — yana daidaita yanayin barcinka.",
    "sleep3": "Shan ranar safe na minti 10 yana daidaita yanayin barcinka yadda ya kamata.",
    "general1": "Numfashi a hankali na minti biyu yana rage damuwa da sa natsuwa.",
    "general2": "Ka lura da abu ɗaya da kake godiya a kai a yau — jin daɗin zuciya shima lafiya ne.",
    "general3": "Ƙoƙarin da ka yi na zuwa yau babbar nasara ce. Wannan ne ke sa sauran dabi'u zama da sauƙi."
  },
  "factors": {
    "hydration": "shan ruwa",
    "nutrition": "abinci mai gina jiki",
    "movement": "motsa jiki",
    "sleep": "barci"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "An kasa loda bayanan abinci",
    "prefsSaved": "An ajiye abubuwan da ka fi so! Ana sake loda abinci...",
    "prefsSaveFail": "An kasa ajiye abubuwan da ka fi so",
    "newOptionsFail": "An kasa loda sabbin zabuka",
    "invalidZip": "Da fatan za a saka lambar gidan waya (zip code) mai lambobi 5",
    "noVendorsArea": "Ba a sami masu sayar da abinci a wannan yankin ba tukunna. Muna fadada ayyukanmu!",
    "vendorsFetchFail": "An kasa loda masu sayar da abinci",
    "selectVendorFirst": "Da fatan za a fara zabar mai sayarwa",
    "removedFromCart": "An cire daga kwandon sayayya",
    "orderPlaced": "An yi odar nasara! 🎉",
    "enterZipFirst": "Da fatan za a fara saka lambar gidan waya a bangaren isar da sako",
    "mealNotAvailable": "Wannan abincin ba zai iya isa yankinka ba a halin yanzu",
    "mealUnavailable": "Wannan abincin ba ya samuwa daga masu sayarwa na kusa da kai",
    "vendorOptionsFail": "An kasa loda zabukan masu sayarwa",
    "favoriteSaveFail": "An kasa ajiye abincin da aka fi so",
    "removedFromFavorites": "An cire daga jerin abubuwan da aka fi so",
    "favoriteRemoveFail": "An kasa cirewa daga jerin abubuwan da aka fi so",
    "cartEmpty": "Kwandon sayayyarka babu komai",
    "noMealOptions": "Babu zabukan abinci da ke akwai",
    "loadingOptions": "Ana loda zabukan abinci...",
    "selectPreferences": "Zabi Abubuwan Da Ka Fi So Game Da Abinci",
    "mealBuilder": "Mai Tsara Abinci",
    "myFavorites": "Abubuwan Da Na Fi So",
    "myFavoriteMeals": "Abincin Da Na Fi So",
    "noFavoritesYet": "Ba ka da abincin da ka fi so tukunna!",
    "price": "Farashi",
    "delivery": "Isar da Sako",
    "deliveryFee": "Kudin Isarwa",
    "distance": "Nisa",
    "subtotal": "Jimillar Dan Takaitaccen Lokaci",
    "total": "Jimilla",
    "orderNumber": "Lambar Oda",
    "vendor": "Mai Sayarwa",
    "totalAmount": "Jimillar Kudi",
    "estimatedDelivery": "Lokacin Isarwa",
    "whyThisMeal": "Dalilin zabar wannan abincin",
    "selectThisMeal": "Zabi Wannan Abincin",
    "swapMeal": "Sauya Abinci",
    "orderThisMeal": "Yi Odar Wannan Abincin",
    "notAvailableNearYou": "Ba ya samuwa kusa da kai",
    "tryAdjustingPrefs": "Gwada canza abubuwan da ka fi so don ganin shawarwarin abinci",
    "myMealPlanSummary": "Takaitaccen Tsarin Abinci Na",
    "saveCompletePlan": "Ajiye Cikakken Tsarin",
    "yourFoodPreferences": "Abubuwan Da Ka Fi So Game Da Abinci",
    "editPreferences": "Gyara Abubuwan Da Ka Fi So",
    "healthyMealDelivery": "Isar Da Abinci Mai Gina Jiki",
    "enableDelivery": "Kunna Isar Da Sako",
    "enterZipCode": "Saka Lambar Gidan Waya Don Ganin Abincin Da Ke Akwai",
    "enterPostcode": "Saka Lambar Gidan Waya",
    "postcodePlaceholder": "Misali, MK10 9XX ko 10001",
    "postcodePartialHint": "Da fatan za a saka cikakken lambar gidan waya don samun sakamako daidai a yankinka.",
    "noLocalPartnersFallback": "Ba a sami abokan hulda a yankin nan ba tukunna. Ana nuna shawarwarin sinadaran abinci na al'ada maimakon haka.",
    "noLivePartnersFallback": "Babu abokan hulda na HealthLoop a halin yanzu a yankinka.",
    "culturalNutritionTitle": "Abincin Gargajiya Mai Gina Jiki",
    "culturalNutritionSubtitle": "Jagorar rayuwa mai kyau — wadda ta dace da al'ada, bayyananniya, kuma aka tsara ta don yankinka.",
    "viewIngredientGuidance": "Duba Jagora",
    "popularWellnessTitle": "Abincin Lafiya Da Aka Fi Sani Kusa Da Kai",
    "popularWellnessIntro": "Sinadaran abinci na al'ada da wuraren cin abinci masu kyau da mutane ke yawan ziyarta a yankinka.",
    "subsectionPopularFoodsTitle": "Abincin Lafiya Na Kullum",
    "subsectionCulturalIngredientsTitle": "Shawarwarin Sinadaran Gargajiya",
    "subsectionHealthySwapsTitle": "Dabarun Sauya Abinci Don Lafiya",
    "subsectionLocalEnvironmentTitle": "Yanayin Lafiya Na Yankin",
    "subsectionLocalEnvironmentIntro": "Wuraren da mutane a yankinka ke samun abinci mai kyau kuma na gargajiya.",
    "findLocalTitle": "Zabukan Lafiya Na Yankin",
    "findLocalSubtitle": "Gano masu sayarwa na kusa, shaguna, da sinadaran abinci na al'ada a yankinka.",
    "findOptions": "Nemo Zabuka",
    "searching": "Ana nema…",
    "nearbyVendorsFound": "An sami zabukan lafiya {{count}} a kusa",
    "orderHintEnabled": "Taba \"Yi Odar Wannan Abincin\" a jikin katin abinci don ganin farashi.",
    "orderHintDisabled": "Kunna \"Isar Da Sako\" a sama don yin odar wadannan abincin kai tsaye.",
    "localIngredientTitle": "Samuwar Sinadaran Abinci A Yankin",
    "localIngredientIntro": "Abincin gargajiya na yau da kullum da inda za a same su a yankinka.",
    "lookFor": "Nemo",
    "noVendorsFallback": "Babu masu isar da abinci da aka amince da su a nan tukunna — amma za ka iya amfani da jagorar sinadaran abinci a kasuwannin kusa da kai.",
    "showingMealsFrom": "Ana nuna abinci daga",
    "sectionSnapshot": "Takaitaccen Labarin Abincin Yau",
    "sectionSnapshotSubtitle": "Duba yanayin shan ruwa, adadin kuzari, da daidaiton abinci na yau.",
    "snapshotHydration": "Shan Ruwa",
    "snapshotHydrationHint": "Yi kokarin shan kofuna 6–8 yau.",
    "snapshotCalories": "Adadin Kuzari (Calories)",
    "snapshotCaloriesHint": "Aikin bin diddigi na nan tafe.",
    "snapshotBalance": "Daidaiton Abinci",
    "mealsLogged": "abincin da aka zaba",
    "snapshotTip": "Shawarar Lafiya",
    "snapshotTipHint": "Kara kayan lambu daya a abincinka na gaba.",
    "sectionRecommendations": "Shawarwari Masu Wayo",
    "sectionRecommendationsSubtitle": "Jagorar sinadaran abinci na al'ada da dabarun sauya abinci don lafiya.",
    "sectionGoals": "Manufofin Abinci",
    "sectionGoalsSubtitle": "Bin diddigin sakamakon da ke da muhimmanci a gare ka.",
    "goalWeight": "Kula Da Kiba",
    "goalWeightDesc": "Abincin da aka tsara don kiyaye nauyin jiki.",
    "goalEnergy": "Kara Kuzari",
    "goalEnergyDesc": "Abincin da ke ba da kuzari na tsawon rana.",
    "goalImmunity": "Karfafa Garkuwar Jiki",
    "goalImmunityDesc": "Abinci mai sinadarin 'antioxidant' don kariya daga rashin lafi.",
    "goalFamily": "Abincin Iyali",
    "goalFamilyDesc": "Har da zabukan da suka dace da yara da mata masu juna biyu.",
    "sectionGuidance": "Jagorar Abinci",
    "sectionGuidanceSubtitle": "Abincin safe, rana, dare, da abun kwalama da za ka iya sauyawa yadda kake so.",
    "futureNutritionTitle": "Taimakon Abinci Na Gaba",
    "futureNutritionBody": "Tsarin abincin lafiya na kanka, hadin gwiwa da masu samar da abinci, da taimakon abincin iyali za su zo cikin HealthLoop nan gaba.",
    "comingSoon": "Yana Nan Tafe",
    "coverageLocalStores": "Shagunan abincin lafiya na kusa",
    "coverageLocalFarms": "Gonakin karkara",
    "coverageCertifiedVendors": "Masu sayarwa da aka amince da su",
    "coverageFreshProduce": "Sabbin kayan gona",
    "medWellnessFutureTitle": "Taimakon Magunguna da Lafiya",
    "medWellnessFutureDesc": "Hada tsarin abincinka da jagorar magunguna. Ana samun wannan a bangaren Taimako (Support & Help).",
    "pharmacyAssistFutureTitle": "Taimakon Kemis/Farmaki",
    "pharmacyAssistFutureDesc": "Nemo shagunan magani na kusa da tunatarwar shan magani tare da abincinka.",
    "savePreferences": "Ajiye Abubuwan Da Aka Fi So",
    "quickAccessSavedMeals": "Hanya mafi sauki don samun abincin da ka ajiye",
    "saveMealsFromBuilder": "Ajiye abinci daga bangaren Tsara Abinci",
    "chooseVendor": "Zabi mai sayarwa don yin odar wannan abincin",
    "yourCart": "Kwandon Sayayyarka",
    "addMealsToStart": "Saka abinci daga zabukan da ke kasa don farawa",
    "orderPlacedDesc": "An yi odar abincinka mai gina jiki cikin nasara",
    "continueShopping": "Ci gaba da Saye-saye",
    "trackOrder": "Bi Diddigin Oda",
    "healthyStoresTitle": " Shagunan Abinci Mai Gina Jiki & Kasuwannin Lafiya na Kusa",
    "healthyStoresIntro": "Ire-iren shaguna daban-daban da za ka duba a yankinka — don samun ra'ayoyi ne, ba don oda ba.",
    "healthyStoresGuidanceTitle": "Jagorar siyayyar abinci mai gina jiki",
    "healthyStoresDisclaimer": "HealthLoop yana raba shawarwarin samun lafiya da ra'ayoyin siyayya mai kyau kawai — ba shawarar magani ba ce ko ta abincin asibiti.",
    "healthyStores": {
      "organic": {
        "type": "Shagunan abinci na 'Organic'",
        "description": "Sabbin kayan gona ba tare da maganin fesa ƙwari ba da kuma kayan abinci da ba a sarrafa su da yawa ba.",
        "tags": [
          "Abinci na asali",
          "Sabbin kayan lambu"
        ]
      },
      "farmers": {
        "type": "Kasuwannin manoma",
        "description": "Sabbin ’ya’yan itatuwa na lokaci, kayan lambu, da amfanin gona na gargajiya kai tsaye daga manoma.",
        "tags": [
          "Na gida",
          "Na lokaci"
        ]
      },
      "african": {
        "type": "Shagunan kayan gona na Afirka",
        "description": "Doya, ayaba (plantain), ganye, man ja/man kwa-kwa da sauran kayan abinci na Yammacin da Gabashin Afirka.",
        "tags": [
          "Na al'ada",
          "Sabbin kayan gona"
        ]
      },
      "caribbean": {
        "type": "Kasuwannin abinci na Caribbean",
        "description": "Callaloo, rogo, barkono, 'ackee', 'breadfruit' da sauran muhimman abincin tsibiri.",
        "tags": [
          "Na al'ada",
          "Abinci na asali"
        ]
      },
      "asian": {
        "type": "Manyan shagunan kayan lambun Asiya",
        "description": "Bok choy, daikon, lotus root, tofu, ganyen ƙanshi da sauran kayan abincin Asiya.",
        "tags": [
          "Na al'ada",
          "Sabbin kayan gona"
        ]
      },
      "halal": {
        "type": "Kasuwannin abinci na Halal",
        "description": "Naman da aka tabbatar da shi a matsayin Halal, sabbin kayan gona da kayan yaji na gargajiya.",
        "tags": [
          "Halal",
          "Na al'ada"
        ]
      },
      "mediterranean": {
        "type": "Kasuwannin abinci na Mediterranean",
        "description": "Man zaitun, wake, ganyen ƙanshi, hatsi da sauran abincin yankin Mediterranean.",
        "tags": [
          "Na al'ada",
          "Abinci na asali"
        ]
      },
      "wellness": {
        "type": "Shagunan abinci na lafiya",
        "description": "Zababben abinci na asali, abincin ganye, da kayan abinci masu inganci.",
        "tags": [
          "Abinci na asali",
          "Abincin ganye"
        ]
      }
    },
    "healthyShoppingTips": [
      "Fara duba gefen shagon — yawancin sabbin kayan lambu da furotin suna gefe-gefen shago ne.",
      "Fi son abinci na asali mai sinadari guda ɗaya maimakon abincin da aka sarrafa da yawa.",
      "Zaɓi kayan gona na lokaci daga manoma na kusa — yawanci sun fi sabo, ba su da tsada kuma suna da amfani.",
      "Tambayi masu sayarwa game da inda abincin ya fito da yadda aka shuka shi — da yawa za su yi farin cikin gaya maka."
    ]
  },
  "messages": {
    "success": "An yi nasara!",
    "error": "Akwai kuskure",
    "saved": "An ajiye cikin nasara",
    "updated": "An sabunta cikin nasara",
    "deleted": "An goge cikin nasara",
    "confirmDelete": "Ka tabbata kana so ka goge wannan?",
    "networkError": "Matsalar yanar gizo. Da fatan za a sake gwadawa.",
    "somethingWrong": "Wani abu ya faru",
    "failedToLoad": "An kasa loda shafin kula da lafiya",
    "offlineMode": "Ba ka da yanar gizo - ana nuna takaitattun bayanai",
    "locationDenied": "An ki amincewa da ganin wurin da kake. Duba saitin intanet dinka don kunna shi.",
    "locationUnavailable": "Bayanin inda kake ba ya samuwa",
    "locationTimeout": "Neman inda kake ya dauki lokaci mai tsawo. Sake gwadawa.",
    "locationError": "An kasa gano inda kake",
    "locationGranted": "An amince da ganin inda kake! Ana nuna zabukan da ke kusa",
    "locationNotSupported": "Wannan manhajar ba ta goyon bayan gano inda kake",
    "requestingLocation": "Ana neman izinin gano inda kake..."
  },
  "trust": {
    "medicalDisclaimer": "Sanarwar Kan Kula Da Lafiya",
    "privacySecure": "Bayananka na sirri ne kuma suna cikin aminci",
    "dataEncrypted": "Duk bayanai suna fake kuma na sirri ne",
    "notMedicalAdvice": "Ba shawarar likita ba ne",
    "consultProvider": "Koyaushe ka nemi shawara daga ma'aikacin lafiya",
    "evidenceBased": "Jagora bisa hujjoji",
    "generalEducation": "Ilimin lafiya na gaba daya",
    "preventiveGuidance": "Jagorar kariya",
    "lifestyleSupport": "Don fadakarwa da taimakon yanayin rayuwa",
    "lastUpdated": "An sabunta karshe a",
    "expertReviewed": "Kwararru sun duba",
    "aiGenerated": "Bayanin basirar na'ura (AI)",
    "disclaimerShort": "HealthLoop tana ba da ilimin lafiya ne kawai, kuma ba ta canjin shawarar kwararren likita.",
    "disclaimerFull": "HealthLoop tana taimakawa wajen kiyaye lafiya da fadakarwa da wuri. Muna ba da ilimin lafiya, bin diddigin dabi'u, da bayanan jin dadi. Wannan ba madadin kula da lafiya daga kwararre ba ne. Koyaushe ka tuntubi kwararrun ma'aikatan lafiya don shawarar likita, bincike, ko magani.",
    "trustBanner": {
      "title": "HealthLoop tana nan don taimaka maka a tafiyar neman lafiyarka",
      "description": "Muna ba da ilimin lafiya na gaba daya da jagorar kariya bisa ingantattun majiyoyi. Wannan ba madadin shawarar likita ba ne. Koyaushe ka tuntubi kwararrun ma'aikatan lafiya kafin yanke shawarar lafiya."
    }
  },
  "health": {
    "preventiveHealth": "Bin Diddigin Kariyar Lafiya",
    "educationHub": "Cibiyar Ilimi",
    "engagementWidget": "Shafin Ayyuka",
    "wellnessCheckIn": "Duba Yanayin Lafiya",
    "todaysMetrics": "Ma'aunan Yau",
    "bloodPressure": "Hawan Jini",
    "heartRate": "Bugun Zuciya",
    "weight": "Nauyi",
    "sleep": "Barci",
    "waterIntake": "Shan Ruwa",
    "exercise": "Motsa Jiki",
    "logMetric": "Rikoda Ma'auni",
    "viewHistory": "Duba Tarihi"
  },
  "aiInsights": {
    "title": "Bayanai Kan Lafiya Daga AI",
    "comingSoon": "Ana tattara bayananka",
    "comingSoonDesc": "Yi duba lafiyar yau da kullum sau daya ko biyu, za mu fara nuna maka takaitattun shawarwari a nan.",
    "learnMore": "Koyi karatu",
    "evidenceSources": {
      "WHO": "Bisa jagororin WHO",
      "NHS": "Ya dace da shawarwarin NHS",
      "CDC": "Bisa goyon bayan jagororin CDC",
      "RESEARCH": "Bisa binciken masana",
      "CLINICAL": "Bisa binciken asibiti"
    }
  },
  "dailyInsight": {
    "title": "Bayanin Lafiya Na Yau",
    "gettingStarted": "Farawa",
    "focus": "Abun Mayar Da Hankali",
    "quickInsight": "Takaitaccen Bayani",
    "simpleExplanation": "Bayani Mai Sauki",
    "realLifeImpact": "Amfanin A Rayuwa",
    "yourActionStep": "Matakin Da Za Ka Dauka",
    "basedOnYour": "Dangane da naka",
    "personalizedFor": "An tsara maka wannan bisa bayanan lafiyarka na kwanan nan",
    "getNewInsight": "Sami sabon bayani",
    "newInsightLoaded": "An loda sabon bayani! 💡",
    "failedToRefresh": "An kasa sabunta bayani",
    "priority": {
      "high": "Bari Mu Maida Hankali A Nan",
      "medium": "Yana Da Kyau A Lura"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Babu sanarwar lafiya a halin yanzu",
    "noAlertsDesc": "Kana kiyaye dabi'un lafiya masu kyau. Ci gaba da haka!",
    "whatYouCanDo": "Abin da za ka iya yi:",
    "viewMealSuggestions": "Duba Shawarwarin Abinci Na Kanka"
  },
  "engagement": {
    "currentStreak": "Kokarin Da Ka Yi A Jere",
    "bestStreak": "Kokarin Da Ya Fi Kyau",
    "thisWeek": "Wannan Makon",
    "exerciseDays": "Kwanakin Motsa Jiki",
    "hydrationDays": "Kwanakin Shan Ruwa",
    "healthMetricsLogged": "Ma'aunan Lafiya Da Aka Rikoda",
    "weeklyGoalsProgress": "Nasara Kan Manufofin Mako",
    "completed": "an kammala",
    "days": "kwanaki",
    "keepGoing": "Ci gaba da kokari!",
    "personalRecord": "Bajintar kanka!",
    "goalMet": "An cimma manufa!"
  },
  "reminders": {
    "title": "Tunatarwar Lafiya",
    "subtitle": "Kiyaye lokaci tare da sanarwar lafiya ta kanka",
    "breakfast": "Tunatarwar Abincin Safe",
    "lunch": "Tunatarwar Abincin Rana",
    "dinner": "Tunatarwar Abincin Dare",
    "water": "Shan Ruwa",
    "movement": "Lokacin Motsa Jiki",
    "sleep": "Tunatarwar Barci",
    "wellness": "Duba Yanayin Lafiya",
    "healthLogging": "Rikoda Bayanan Lafiya",
    "annualCheckup": "Gwajin Lafiya Na Shekara",
    "enable": "Kunna",
    "disable": "Kashe",
    "customize": "Gyara Lokaci",
    "stayConsistent": "Kasance Mai Kula Da Lokaci",
    "setupFriendly": "Saita tunatarwa masu dadi don taimaka maka gina dabi'u masu kyau.",
    "customizeWhen": "Za ka iya zaba lokacin da yawan yadda kake son samun kowace tunatarwa.",
    "supportive": "Kada ka damu - za su zama masu taimako ba tare da damun ka ba! 💚",
    "noPreferences": "Ba a Sami Saitin Tunatarwa Ba",
    "noPreferencesDesc": "Ba mu iya loda saitin tunatarwarka ba. Watakila wannan ne karon farko, ko kuma an sami matsala wajen loda saitin.",
    "retryLoading": "Sake Gwada Loda",
    "saveSettings": "Ajiye Saiti",
    "saving": "Ana ajiye..."
  },
  "empty": {
    "startJourney": "Fara Tafiyar Lafiyarka",
    "startJourneyDesc": "Fara tafiyar lafiyarka yau! Fadi yadda kake ji don samun shawarwari da bin diddigin jin dadinka a tsawon lokaci.",
    "completeFirstCheckIn": "Kammala Duba Lafiya Na Farko",
    "stayOnTrack": "Kiyaye Shirinka",
    "stayOnTrackDesc": "Kasance mai bin ka'ida 💊 Saka magungunanka don samun tunatarwa da taimako.",
    "addFirstMedication": "Saka Magani Na Farko",
    "learnMedicationSafety": "Koyi Game Da Kare Lafiyar Magunguna",
    "buildMealLibrary": "Gina Taskar Abincinka",
    "buildMealLibraryDesc": "Ba ka da abincin da ka fi so tukunna. Ajiye abincin da kake so don samun su cikin sauki.",
    "exploreMealOptions": "Bincika Zabukan Abinci",
    "insightsAwait": "Shawarwarinka Suna Jira",
    "insightsAwaitDesc": "Kammala duba lafiyar yau da kullum don samun shawarwarin lafiya da nazarin yanayin jikinka.",
    "startDailyCheckIn": "Fara Duba Lafiya Na Kullum",
    "learnAboutInsights": "Koyi Game Da Shawarwari",
    "buildingStory": "Gina Labarin Lafiyarka",
    "buildingStoryDesc": "Babu bayanan baya tukunna. Yanayin lafiyarka zai bayyana a nan yayin da kake rikoda yadda kake ji kullum.",
    "completeCheckIn": "Kammala Duba Lafiya",
    "tipComplete7Days": "Shawara: Yi duba lafiya na kwanaki 7 don ganin yadda lafiyarka ke sauyawa.",
    "startTrackingHabits": "Fara Bin Diddigin Dabi'u Masu Kyau",
    "startTrackingHabitsDesc": "Ba a fara bin diddigin dabi'u ba tukunna. Kananan ayyukan yau da kullum ne ke kawo canji mai dorewa.",
    "trackFirstHabit": "Fara Bin Diddigin Dabi'a Ta Farko",
    "getMoving": "Fara Motsa Jiki",
    "getMovingDesc": "Ba ka yi rikoda motsa jiki ba tukunna. Ko da motsa jiki na mintuna 10 zai iya kara maka kuzari.",
    "logActivity": "Rikoda Aiki",
    "allCaughtUp": "Duk Abun Da Ya Kamata An Yi!",
    "allCaughtUpDesc": "Ba ka da sabbin sanarwa. Dawo nan gaba don sabbin labarai da tunatarwa.",
    "noResultsFound": "Ba a Sami Sakamako Ba",
    "noResultsFoundDesc": "Ba mu sami komai akan \"{query}\" ba. Gwada sake neman wani abun ko bincika wasu zabukan."
  },
  "footer": {
    "tagline": "Abokin Tafiyarku na AI Don Rigakafin Cututtuka",
    "builtWith": "An gina shi cikin ƙauna don dacewar lafiyar ku",
    "allRightsReserved": "An kiyaye duk haƙƙoƙi.",
    "about": "Game da mu",
    "privacy": "Sirri",
    "terms": "Sharuɗɗa",
    "contact": "Tuntuɓi",
    "helpCenter": "Cibiyar Taimako"
  },
  "modals": {
    "feedback": {
      "title": "Aiko da Ra'ayoyin ku",
      "subtitle": "Taimaka mana mu inganta HealthLoop",
      "whatWorking": "Mene ne kuka ga yana aiki da kyau?",
      "whatImprove": "Mene ne ya kamata mu inganta?",
      "placeholder": "Bayyana ra'ayoyin ku...",
      "thankYou": "Mun gode da ra'ayoyin ku!",
      "submitted": "Ra'ayoyin ku na taimaka mana wajen kyautata HealthLoop."
    },
    "reportProblem": {
      "title": "Bayar da Rahoton Matsala",
      "subtitle": "Taimaka mana mu gyara kurakurai mu kuma inganta manhajar",
      "describe": "Bayyana matsalar",
      "placeholder": "Me ya faru? Da fatan za a yi bayani daki-daki...",
      "optional": "Zabika: Matakan da kuka bi har matsalar ta faru",
      "stepsPlaceholder": "1. Na danna kan...\n2. Sannan na...",
      "thankYou": "Mun gode da rahbarin da kuka bayar!",
      "submitted": "Zamu duba wannan matsalar nan take."
    },
    "mealPreferences": {
      "title": "Tsara Abincin ku",
      "subtitle": "Faɗa mana nau'ikan abincin da kuka fi so",
      "cuisines": "Abincin da aka fi so",
      "selectCuisines": "Zaɓi duk waɗanda suka dace",
      "dietary": "Zaɓin Abinci don Lafiya",
      "selectDietary": "Zaɓi buƙatun abincinku",
      "allergies": "Abincin da ba ku so ko kuke ƙyamata",
      "allergiesPlaceholder": "Misali: Gyada, Kifi, Alkama (Gluten)",
      "save": "Ajiye Zaɓi",
      "saving": "Ana adanawa..."
    },
    "upgrade": {
      "title": "Koma zuwa Premium",
      "subtitle": "Buɗe dukkan ayyukan manhajar",
      "features": "Ayyukan Premium",
      "getStarted": "Fara Yanzu",
      "learnMore": "Ƙara sani"
    }
  },
  "login": {
    "title": "Dandalin ku na Lura da Lafiyar Rigakafi",
    "subtitle": "Bibiyi, koya, kuma ɗauki mataki kafin matsalolin lafiya su tsananta. An gina shi don rigakafi, ilimantarwa, da jin daɗin rayuwa.",
    "email": "Imel",
    "password": "Kalmar sirri",
    "signIn": "Shiga Ciki",
    "signingIn": "Ana shiga...",
    "forgotPassword": "Kun manta kalmar sirri?",
    "noAccount": "Ba ku da asusu?",
    "createAccount": "Ƙirƙiri ɗaya",
    "biometricLogin": "Shiga da Siffar Jiki (Biometrics)",
    "biometricHelper": "Yi amfani da sawun yatsa, fuska (Face ID), ko Windows Hello",
    "authenticating": "Ana tantancewa...",
    "vendorPartner": "Kuna da alaƙar kasuwanci da mu?",
    "vendorLogin": "Hanyar Shiga na Masu Kasuwanci",
    "emailRequired": "Da fatan za a fara shigar da imel ɗinku",
    "biometricSuccess": "An yi nasarar shiga da siffar jiki! 🎉",
    "noPasskeys": "Ba a saita shigar siffar jiki ba. Da fatan za a fara shiga da kalmar sirri.",
    "biometricCancelled": "An soke shiga da siffar jiki",
    "biometricFailed": "An kasa shiga da siffar jiki. Da fatan za a gwada da kalmar sirri."
  },
  "register": {
    "title": "Kasance a HealthLoop",
    "subtitle": "Fara tafiyar rigakafin lafiyar ku a yau",
    "fullName": "Cikakken Suna",
    "email": "Imel",
    "password": "Kalmar sirri",
    "confirmPassword": "Tabbatar da Kalmar sirri",
    "createAccount": "Buɗe Akant",
    "haveAccount": "Kuna da akant riga?",
    "signIn": "Shiga Ciki",
    "creating": "Ana buɗe akant...",
    "passwordTooShort": "Dole kalmar sirri ta kasance akalla haruffa 8",
    "setupBiometric": "Saita Shiga da Siffar Jiki",
    "setupBiometricDesc": "Yi amfani da sawun yatsa ko fuska don saurin shiga cikin tsaro",
    "setupNow": "Saita Yanzu",
    "skipForNow": "Kyale yanzu",
    "settingUp": "Ana saitawa...",
    "benefit1": "Ba sai kun tuna kalmomin sirri ba",
    "benefit2": "Ƙarin tsaro tare da tantance siffar jiki",
    "benefit3": "Shiga da taɓawa ko kallo ɗaya kawai",
    "biometricPrivacy": "Bayanan siffar jikin ku ba sa fita daga na'urar ku",
    "biometricSuccess": "An yi nasarar saita shigar siffar jiki! 🎉",
    "biometricFailed": "An kasa saita shigar siffar jiki. Kuna iya saitawa daga baya a saituna.",
    "biometricSetupLater": "Kuna iya saita shigar siffar jiki daga baya a cikin saitunan ku"
  },
  "womensHealthPage": {
    "title": "Bibiyar Lafiyar Mata",
    "subtitle": "Bibiyi al'ada, alamomin jiki, da dacewar lafiya",
    "cycleOverview": "Bayanin Yanayin Al'ada",
    "currentPhase": "Matakin da ake ciki",
    "nextPeriod": "Lokacin Al'ada Na Gaba",
    "logPeriod": "Yi rikodin Al'ada",
    "logSymptoms": "Yi rikodin Alamomin Jiki",
    "insights": "Fahimtar Yanayin Al'ada",
    "tips": "Shawarwarin Matakan Al'ada",
    "history": "Tarihin Al'ada",
    "noData": "Babu bayanan al'ada tukunna",
    "noDataDesc": "Fara bibiyar al'adarku don samun haske da hasashen da suka dace da ku.",
    "startTracking": "Fara Bibiya"
  },
  "notifications": {
    "title": "Sanarwa",
    "markAllRead": "Sanya duka a matsayin an karanta",
    "noNotifications": "Babu sabuwar sanarwa",
    "viewAll": "Duba Duka"
  },
  "familyHealth": {
    "title": "Lafiyar Iyali da Yara",
    "subtitle": "Taimakon rigakafin lafiya ga daukacin iyalinka",
    "tabImmunizations": "Rigakafin Allura",
    "tabEducation": "Ilimantarwa",
    "tabReminders": "Tuna-da-kai",
    "tabPlanner": "Tsarin Iyali",
    "immunizations": {
      "title": "Wayar da Kai Kan Rigakafi",
      "subtitle": "Kasance da masaniya kan alluran rigakafi",
      "recommendedSchedule": "Jadawalin da aka Shawarta",
      "byAge": "Ta rukunin Shekaru",
      "infants": "Jarirai (wata 0-12)",
      "toddlers": "Yara (shekara 1-3)",
      "preschool": "Yaran da ba su kai makaranta ba (shekara 4-6)",
      "schoolAge": "Yaran makaranta (shekara 7-12)",
      "teens": "Matasa (shekara 13-18)",
      "adults": "Manyan mutane",
      "learnMore": "Ƙara sani",
      "consultDoctor": "A koyaushe tuntuɓi ma'aikacin lafiyar ku don shawarwarin rigakafi na kashin kanku",
      "upcomingReminders": "Tunasarwar Alluran Rigakafi Masu Zuwa",
      "noReminders": "Babu tunasarwar rigakafi mai zuwa",
      "addReminder": "Ƙara Tunasarwar Rigakafi",
      "reminderFor": "Tunasarwa ga",
      "dueDate": "Ranar da Ya Kamata",
      "notes": "Bayanan ƙarin bayani",
      "markComplete": "Sanya a matsayin an gama"
    },
    "education": {
      "title": "Ilimin Lafiyar Iyali",
      "subtitle": "Ingantaccen bayani kan rigakafin lafiya",
      "categories": "Rukunoni",
      "infant": "Kula da Jarirai",
      "child": "Girmar Yara",
      "nutrition": "Abinci da Girma",
      "safety": "Tsaro da Rigakafi",
      "mental": "Lafiyar Hankali",
      "hygiene": "Tsafta da Halaye",
      "searchPlaceholder": "Nemi bayanan lafiya...",
      "popularTopics": "Batutuwan da aka fi bi",
      "readMore": "Karanta ƙarin bayani",
      "readTime": "minti na karatu"
    },
    "reminders": {
      "title": "Tunasarwar Lafiyar Iyali",
      "subtitle": "Kasance kan jadawalin kula da rigakafi ga duka iyali",
      "createReminder": "Ƙirƙiri Tunasarwa",
      "familyMember": "Dan uwa",
      "reminderType": "Nau'in Tunasarwa",
      "frequency": "Sau nawa",
      "activeReminders": "Tunasarwa da ke aiki",
      "upcomingThisWeek": "Masu zuwa a wannan makon",
      "noActiveReminders": "Babu tunasarwa da ke aiki yanzu",
      "types": {
        "checkup": "Duba Lafiya",
        "dental": "Duban Haƙori",
        "vision": "Duban Ido",
        "vaccine": "Allurar Rigakafi",
        "medication": "Magani",
        "custom": "Wani daban"
      }
    },
    "planner": {
      "title": "Tsarin Lafiyar Iyali",
      "subtitle": "Tsara kula da rigakafi ga iyalinka",
      "addMember": "Ƙara Ɗan uwa",
      "memberName": "Sunan Ɗan uwa",
      "relationship": "Dangantaka",
      "dateOfBirth": "Ranar Haifuwa",
      "viewCalendar": "Duba Kalanda",
      "upcomingCare": "Kula da Rigakafi Mai Zuwa",
      "nothingScheduled": "Ba a tsara komai ba tukunna",
      "scheduleCheckup": "Tsara Duban Lafiya",
      "relationships": {
        "child": "Yaro",
        "spouse": "Mata/Miji",
        "parent": "Mahaifi",
        "sibling": "Ɗan uwa",
        "other": "Sauran"
      }
    },
    "content": {
      "infantCare": {
        "title": "Kula da Jarirai don Rigakafi",
        "intro": "Muhimman ayyukan rigakafin lafiya ga shekarar farko ta jaririnku",
        "topics": [
          "Jadawalin duba lafiyar jariri",
          "Matakan ci gaba da ya kamata a lura",
          "Hanyoyin barci mai aminci",
          "Abinci da shayarwa",
          "Jadawalin allurar rigakafi"
        ]
      },
      "childDevelopment": {
        "title": "Girmar Yara da Matakan Ci gaba",
        "intro": "Fahimtar girma da ci gaban lafiya",
        "topics": [
          "Matakan ci gaban jiki",
          "Girma ta fuskar hulɗa da jin daɗi",
          "Ci gaban harshe",
          "Matakan fahimta",
          "Yaushe ne ya kamata a tuntuɓi likita"
        ]
      },
      "nutrition": {
        "title": "Abinci da Girmar Lafiya",
        "intro": "Gina kyawawan halayen cin abinci tun daga farko",
        "topics": [
          "Abincin da ya dace da shekaru",
          "Shawarwarin abinci mai gina jiki",
          "Yadda za a bi da yaro mai zaɓen abinci",
          "Tsaftar abinci",
          "Ka'idojin shan ruwa"
        ]
      },
      "safety": {
        "title": "Tsaro da Rigakafin Raunuka",
        "intro": "Gina yanayi mai aminci ga iyalinka",
        "topics": [
          "Jerin tsaron gida",
          "Tsaron kujerar mota ta yara",
          "Tsaro kusa da ruwa",
          "Rigakafin guba",
          "Shirye-shiryen gaggawa"
        ]
      }
    }
  }
};
